import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import useTutorData from "Views/people/tutor/data/tutorTableData";
import useParentsData from "Views/people/parents/data/parentsTableData";
import { useState, useEffect, useRef, Fragment } from "react";
import ArgonInput from "components/ArgonInput";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import { fontSize, height, width } from "@mui/system";
import ArgonButton from "components/ArgonButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL } from "utils/api";
import api from "utils/api";
import { toast } from "react-toastify";
import {
  Paper,
  Avatar,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
  Checkbox,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GroupsIcon from "@mui/icons-material/Groups";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SchoolIcon from "@mui/icons-material/School";
import { matchesCRMSearch } from "utils/crmSearch";
import {
  ADMIN_UNREAD_MODULES,
  getAdminUnreadCounts,
  markAdminUnreadSeen,
} from "services/adminUnreadService";

const appliedTutorSections = [
  {
    key: "applied",
    label: "Applied",
    caption: "New tutor applications",
    color: "#5e72e4",
    bg: "rgba(94, 114, 228, 0.1)",
  },
  {
    key: "shortlisted",
    label: "Shortlisted",
    caption: "Shared with parent",
    color: "#fb8c00",
    bg: "rgba(251, 140, 0, 0.12)",
  },
  {
    key: "confirmed",
    label: "Confirmed",
    caption: "Tutor finalized",
    color: "#2e7d32",
    bg: "rgba(46, 125, 50, 0.12)",
  },
  {
    key: "rejected",
    label: "Rejected",
    caption: "Not selected",
    color: "#d32f2f",
    bg: "rgba(211, 47, 47, 0.12)",
  },
];

const getEmptyAppliedTutorGroups = () => ({
  applied: [],
  shortlisted: [],
  confirmed: [],
  rejected: [],
});

function UnifiedCRM() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine initial tab based on route or prop
  const getInitialTab = () => {
    if (location.pathname.includes("tutor")) return 1;
    if (location.pathname.includes("parent")) return 0;
    return 0; // Default to Parent CRM
  };

  // Main tab state for Parent/Tutor switching
  const [mainTabValue, setMainTabValue] = useState(getInitialTab);
  // Status filter state for the ApnaTabs
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchQueries, setSearchQueries] = useState({ 0: "", 1: "" });
  const searchQuery = searchQueries[mainTabValue];
  const kanbanBoardRef = useRef(null);
  const kanbanStageRefs = useRef({});
  const kanbanCardListRefs = useRef({});
  // Refresh trigger for data
  const [refresh, setRefresh] = useState(0);
  // View mode: 'table' or 'kanban'
  const [viewMode, setViewMode] = useState("kanban");
  // CRM data
  const [crmData, setCrmData] = useState([]);
  // Dragging state
  const [draggedItem, setDraggedItem] = useState(null);
  // Loading state
  const [loading, setLoading] = useState(false);
  // State to track which parents should show combined view (default: all combined)
  const [combinedParents, setCombinedParents] = useState({});
  // State to track student-level status overrides: {crmItemId-studentId: status}
  const [studentLevelStatuses, setStudentLevelStatuses] = useState({});
  // Drawer state for detail view
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDetailData, setSelectedDetailData] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [crmNewCounts, setCrmNewCounts] = useState({
    parentNewCount: 0,
    tutorNewCount: 0,
    totalNewCount: 0,
  });
  const [crmBoardCounts, setCrmBoardCounts] = useState({
    parent: 0,
    tutor: 0,
  });

  //popup
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // OTM popup state
  const [otmPopupOpen, setOtmPopupOpen] = useState(false);
  const [otmAmount, setOtmAmount] = useState("");
  const [partialAmount, setPartialAmount] = useState("");
  const [currentOtmItem, setCurrentOtmItem] = useState(null);
  const [studentLevelAmounts, setStudentLevelAmounts] = useState([]);

  // Combine/Separate confirmation dialog state
  const [combineConfirmDialog, setCombineConfirmDialog] = useState(false);
  const [pendingCombineAction, setPendingCombineAction] = useState(null);

  // Shortlisted tutors state
  const [shortlistedTutors, setShortlistedTutors] = useState([]);
  const [shortlistedLoading, setShortlistedLoading] = useState(false);

  // Interested tutors state (from leads)
  const [interestedTutors, setInterestedTutors] = useState([]);
  const [interestedLoading, setInterestedLoading] = useState(false);
  const [selectedInterestedTutors, setSelectedInterestedTutors] = useState([]);
  const [appliedTutorCounts, setAppliedTutorCounts] = useState({});
  const [appliedTutorsPopupOpen, setAppliedTutorsPopupOpen] = useState(false);
  const [appliedTutorsPopupLoading, setAppliedTutorsPopupLoading] = useState(false);
  const [appliedTutorStatusTab, setAppliedTutorStatusTab] = useState(0);
  const [selectedAppliedTutorGroups, setSelectedAppliedTutorGroups] = useState(
    getEmptyAppliedTutorGroups()
  );
  const [selectedAppliedParentName, setSelectedAppliedParentName] = useState("");

  // Parent followUp status columns
  const parentFollowUpStatuses = [
    { id: "Enquiry Generated", label: "Enquiry Generated", color: "#667eea" },
    { id: "Tutor Shortlisting", label: "Tutor Shortlisting", color: "#f093fb" },
    { id: "Follow-up & Analysis", label: "Follow-up & Analysis", color: "#4facfe" },
    { id: "No tutor", label: "No tutor", color: "#ff6b6b" },
    { id: "Demo Fixed", label: "Demo Fixed", color: "#feca57" },
    { id: "Demo Done", label: "Demo Done", color: "#48dbfb" },
    { id: "Negotiation & Review", label: "Negotiation & Review", color: "#f368e0" },
    { id: "Junk/ Closed", label: "Junk/ Closed", color: "#c23616" },
    { id: "Won", label: "Won", color: "#44bd32" },
    { id: "Retation & Renewal", label: "Retation & Renewal", color: "#e17055" },
    { id: "OTM", label: "OTM", color: "#0984e3" },
    { id: "OTM - PAID", label: "OTM PARTIAL- PAID", color: "#00b894" },
    { id: "OTM - completed", label: "OTM - completed", color: "#0097e6" },
  ];

  // Tutor followUp status columns
  const tutorFollowUpStatuses = [
    { id: "App Installed", label: "App Installed", color: "#667eea" },
    { id: "Contacted", label: "Contacted", color: "#f093fb" },
    { id: "Follow up", label: "Follow up", color: "#4facfe" },
    { id: "Interview Scheduled", label: "Interview Scheduled", color: "#feca57" },
    { id: "Interview not attended", label: "Interview not attended", color: "#ff6b6b" },
    { id: "R1 rejected", label: "R1 rejected", color: "#c23616" },
    { id: "Offered", label: "Offered", color: "#44bd32" },
    { id: "Documentation pending", label: "Documentation pending", color: "#f368e0" },
    { id: "Onboarded", label: "Onboarded", color: "#0097e6" },
    { id: "R2 hold / Salary offering hold", label: "R2 hold", color: "#fdcb6e" },
    { id: "DONUT ( no verification )", label: "DONUT", color: "#e17055" },
    { id: "Application Withdrawn", label: "Application Withdrawn", color: "#636e72" },
    { id: "Blacklisted", label: "Blacklisted", color: "#2d3436" },
    { id: "Relocated", label: "Relocated", color: "#74b9ff" },
  ];

  // Get current status array based on active tab
  const followUpStatuses = mainTabValue === 0 ? parentFollowUpStatuses : tutorFollowUpStatuses;

  // Fetch CRM data
  useEffect(() => {
    fetchCRMData();
    fetchCRMBoardCounts();
  }, [refresh, mainTabValue]);

  useEffect(() => {
    fetchCRMNewCounts();
    fetchCRMBoardCounts();
  }, []);

  useEffect(() => {
    const refreshVisibleCRM = () => {
      if (document.visibilityState === "visible") {
        setRefresh((currentRefresh) => currentRefresh + 1);
      }
    };

    window.addEventListener("focus", refreshVisibleCRM);
    document.addEventListener("visibilitychange", refreshVisibleCRM);

    return () => {
      window.removeEventListener("focus", refreshVisibleCRM);
      document.removeEventListener("visibilitychange", refreshVisibleCRM);
    };
  }, []);

  useEffect(() => {
    const preloadAppliedTutorCounts = async () => {
      if (mainTabValue !== 0 || !Array.isArray(crmData) || crmData.length === 0) {
        setAppliedTutorCounts({});
        return;
      }

      const parentIds = [
        ...new Set(crmData.map((item) => item.parentId?._id).filter(Boolean)),
      ].filter((parentId) => appliedTutorCounts[parentId] === undefined);

      if (parentIds.length === 0) {
        return;
      }

      try {
        const responses = await Promise.all(
          parentIds.map((parentId) =>
            Promise.all([
              api.get(`/applied-leads/parent?parentId=${parentId}`),
              api.get(`/shortlisted-tutors/parent?parentId=${parentId}`),
            ])
          )
        );

        const nextCounts = {};
        responses.forEach(([appliedResponse, shortlistedResponse], index) => {
          const parentId = parentIds[index];
          const appliedLeads = appliedResponse.data?.success ? appliedResponse.data?.data || [] : [];
          const shortlistedList = shortlistedResponse.data?.success
            ? shortlistedResponse.data?.data || []
            : [];
          const formattedTutors = formatAppliedTutorsFromLeads(appliedLeads);
          const formattedShortlistedTutors = formatShortlistedTutorsForPopup(shortlistedList);
          const groupedTutors = buildAppliedTutorGroups(
            formattedTutors,
            formattedShortlistedTutors
          );

          nextCounts[parentId] = appliedTutorSections.reduce(
            (total, section) => total + groupedTutors[section.key].length,
            0
          );
        });

        setAppliedTutorCounts((prev) => ({
          ...prev,
          ...nextCounts,
        }));
      } catch (error) {
        console.error("Error preloading applied tutor counts:", error);
      }
    };

    preloadAppliedTutorCounts();
  }, [crmData, mainTabValue]);
  const fetchCRMData = async () => {
    try {
      setLoading(true);
      const type = mainTabValue === 0 ? "PARENT" : "TUTOR";
      const allEntries = [];
      let page = 1;
      let totalPages = 1;

      do {
        const response = await api.get("/crm", {
          params: { type, page, limit: 100 },
        });
        const payload = response?.data?.data || {};
        const entries = Array.isArray(payload.crmEntries) ? payload.crmEntries : [];
        const pagination = payload.pagination || {};

        allEntries.push(...entries);
        totalPages = Number(pagination.totalPages) || 1;
        page += 1;
      } while (page <= totalPages);

      console.log("CRM Data:", allEntries);
      console.log("CRM Data Count:", allEntries.length);
      console.log("MainTabValue:", mainTabValue, type);
      setCrmData(allEntries);
      setStudentLevelStatuses({});
    } catch (err) {
      console.error("Error fetching CRM data:", err);
      console.error("Error response:", err.response?.data);
      toast.error(err.response?.data?.message || "Failed to fetch CRM data");
      setCrmData([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const getCRMStudentStatusValue = (item, studentId, statusOverrides = {}) => {
    const statusKey = `${item._id}-${studentId}`;
    if (statusOverrides[statusKey]) {
      return statusOverrides[statusKey];
    }

    const studentStatus = Array.isArray(item.studentLevelStatuses)
      ? item.studentLevelStatuses.find(
          (status) => (status.studentId?._id || status.studentId)?.toString() === studentId.toString()
        )
      : null;

    return studentStatus?.followUpStatus || item.followUpStatus;
  };

  const groupCRMEntriesForKanban = (
    entries,
    statuses,
    type,
    combinedMap = {},
    statusOverrides = {}
  ) => {
    const groupedEntries = statuses.reduce((acc, status) => {
      acc[status.id] = [];
      return acc;
    }, {});

    if (!Array.isArray(entries)) return groupedEntries;

    statuses.forEach((status) => {
      entries.forEach((item) => {
        if (type === "PARENT" && item.parentId?.students?.length > 1) {
          const isCombined = combinedMap[item.parentId._id];

          if (isCombined) {
            if (item.followUpStatus === status.id) {
              groupedEntries[status.id].push(item);
            }
            return;
          }

          const hasStudentWithStatus = item.parentId.students.some(
            (student) =>
              getCRMStudentStatusValue(item, student._id, statusOverrides) === status.id
          );
          if (hasStudentWithStatus) {
            groupedEntries[status.id].push(item);
          }
          return;
        }

        if (item.followUpStatus === status.id) {
          groupedEntries[status.id].push(item);
        }
      });
    });

    const firstStatusId = statuses[0]?.id;
    if (!firstStatusId) return groupedEntries;

    const itemsWithoutStatus = entries.filter((item) => {
      if (
        type === "PARENT" &&
        item.parentId?.students?.length > 1 &&
        !combinedMap[item.parentId._id]
      ) {
        return item.parentId.students.some(
          (student) => !getCRMStudentStatusValue(item, student._id, statusOverrides)
        );
      }
      return !item.followUpStatus;
    });

    if (itemsWithoutStatus.length > 0) {
      const existingIds = new Set(groupedEntries[firstStatusId].map((item) => item._id));
      const newItems = itemsWithoutStatus.filter((item) => !existingIds.has(item._id));
      groupedEntries[firstStatusId] = [...groupedEntries[firstStatusId], ...newItems];
    }

    return groupedEntries;
  };

  const getKanbanCardsFromItems = (
    itemsInStatus,
    statusId,
    type,
    combinedMap = {},
    statusOverrides = {}
  ) =>
    itemsInStatus.flatMap((item) => {
      const userData = type === "PARENT" ? item.parentId : item.tutorId;
      if (!userData) return [];

      if (type === "PARENT" && item.parentId?.students?.length > 1) {
        const isCombined = combinedMap[item.parentId._id];
        if (isCombined) {
          return [{ key: item._id, item, studentData: null }];
        }

        return item.parentId.students
          .filter(
            (student) => getCRMStudentStatusValue(item, student._id, statusOverrides) === statusId
          )
          .map((student) => ({
            key: `${item._id}-${student._id}`,
            item,
            studentData: student,
          }));
      }

      return [{ key: item._id, item, studentData: null }];
    });

  const getCRMKanbanBoardCount = (
    entries,
    statuses,
    type,
    combinedMap = {},
    statusOverrides = {}
  ) => {
    const groupedEntries = groupCRMEntriesForKanban(
      entries,
      statuses,
      type,
      combinedMap,
      statusOverrides
    );

    return statuses.reduce(
      (total, status) =>
        total +
        getKanbanCardsFromItems(
          groupedEntries[status.id] || [],
          status.id,
          type,
          combinedMap,
          statusOverrides
        ).length,
      0
    );
  };

  const fetchCRMEntriesByType = async (type) => {
    const allEntries = [];
    let page = 1;
    let totalPages = 1;

    do {
      const response = await api.get("/crm", {
        params: { type, page, limit: 100 },
      });
      const payload = response?.data?.data || {};
      const entries = Array.isArray(payload.crmEntries) ? payload.crmEntries : [];
      const pagination = payload.pagination || {};

      allEntries.push(...entries);
      totalPages = Number(pagination.totalPages) || 1;
      page += 1;
    } while (page <= totalPages);

    return allEntries;
  };

  const fetchCRMBoardCounts = async () => {
    try {
      const [parentEntries, tutorEntries] = await Promise.all([
        fetchCRMEntriesByType("PARENT"),
        fetchCRMEntriesByType("TUTOR"),
      ]);

      setCrmBoardCounts({
        parent: getCRMKanbanBoardCount(
          parentEntries,
          parentFollowUpStatuses,
          "PARENT",
          combinedParents
        ),
        tutor: getCRMKanbanBoardCount(tutorEntries, tutorFollowUpStatuses, "TUTOR"),
      });
    } catch (error) {
      console.error("Error fetching CRM board counts:", error);
    }
  };

  const fetchCRMNewCounts = async () => {
    try {
      const response = await getAdminUnreadCounts([ADMIN_UNREAD_MODULES.CRM]);
      const counts = response.data?.counts?.[ADMIN_UNREAD_MODULES.CRM] || {};
      setCrmNewCounts({
        parentNewCount: Number(counts.parentNewCount) || 0,
        tutorNewCount: Number(counts.tutorNewCount) || 0,
        totalNewCount: Number(counts.totalNewCount ?? counts.count) || 0,
      });
    } catch (error) {
      console.error("Error fetching CRM new counts:", error);
    }
  };

  const markCRMItemSeen = async (crmId) => {
    if (!crmId) return;

    try {
      await markAdminUnreadSeen(ADMIN_UNREAD_MODULES.CRM, crmId);
      setCrmData((prevData) =>
        Array.isArray(prevData)
          ? prevData.map((crmItem) =>
              crmItem._id === crmId
                ? { ...crmItem, isNewForAdmin: false, adminUnread: false }
                : crmItem
            )
          : prevData
      );
      await fetchCRMNewCounts();
    } catch (error) {
      console.error("Error marking CRM item as seen:", error);
    }
  };

  const renderTabNewCount = (value) => {
    if (value <= 0) return null;

    return (
      <ArgonBox
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 1,
          py: 0.45,
          ml: 0.75,
          borderRadius: "999px",
          backgroundColor: "#f5365c",
          color: "#fff",
          boxShadow: "0 4px 10px rgba(245, 54, 92, 0.22)",
        }}
      >
        <ArgonTypography
          component="span"
          variant="caption"
          fontWeight="700"
          sx={{ color: "inherit", fontSize: "0.72rem", lineHeight: 1 }}
        >
          New
        </ArgonTypography>
        <ArgonTypography
          component="span"
          variant="caption"
          fontWeight="900"
          sx={{ color: "inherit", fontSize: "0.82rem", lineHeight: 1 }}
        >
          {value}
        </ArgonTypography>
      </ArgonBox>
    );
  };

  const renderTabTotalCount = (value) => (
    <ArgonBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.45,
        ml: 0.75,
        borderRadius: "999px",
        backgroundColor: "rgba(94, 114, 228, 0.1)",
        border: "1px solid rgba(94, 114, 228, 0.32)",
        color: "#5e72e4",
      }}
    >
      <ArgonTypography
        component="span"
        variant="caption"
        fontWeight="700"
        sx={{ color: "inherit", fontSize: "0.72rem", lineHeight: 1 }}
      >
        Total
      </ArgonTypography>
      <ArgonTypography
        component="span"
        variant="caption"
        fontWeight="900"
        sx={{ color: "inherit", fontSize: "0.82rem", lineHeight: 1 }}
      >
        {value}
      </ArgonTypography>
    </ArgonBox>
  );

  // Delete button click handler
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null);
  };

  // Handle main tab change
  const handleMainTabChange = (event, newValue) => {
    setMainTabValue(newValue);
    setStatusFilter("All"); // Reset status filter when switching main tabs
  };

  // Handle status tab change from ApnaTabs
  const handleStatusChange = (status) => {
    setStatusFilter(status);
  };

  // Get data using appropriate hooks
  const parentData = useParentsData(handleDeleteClick, refresh);
  const tutorData = useTutorData(handleDeleteClick, "All");

  // Get current data based on selected tab
  const currentData = mainTabValue === 0 ? parentData : tutorData;
  const { columns, rows } = currentData;
  const searchedRows = (rows || []).filter((row) => matchesCRMSearch(row.crmSearchEntity, searchQuery));

  // Match board membership, including parents with student-level stages.
  const tableStageGroups = groupCRMEntriesForKanban(
    crmData,
    followUpStatuses,
    mainTabValue === 0 ? "PARENT" : "TUTOR",
    combinedParents,
    studentLevelStatuses
  );
  const entityKey = mainTabValue === 0 ? "parentId" : "tutorId";
  const tableRowsByStage = Object.fromEntries(
    followUpStatuses.map((stage) => {
      const entityIds = new Set(
        tableStageGroups[stage.id]
          .map((entry) => entry[entityKey]?._id || entry[entityKey]?.id || entry[entityKey])
          .filter(Boolean)
          .map(String)
      );
      return [stage.id, searchedRows.filter((row) => entityIds.has(String(row[entityKey])))];
    })
  );
  const tabsData = [
    { label: "All", status: "All", count: searchedRows.length },
    ...followUpStatuses.map((stage) => ({
      label: stage.label,
      status: stage.id,
      count: tableRowsByStage[stage.id].length,
    })),
  ];
  const filteredTableRows = (statusFilter === "All" ? searchedRows : tableRowsByStage[statusFilter] || [])
    .map((row, index) => ({
      ...row,
      sno: (
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {index + 1}
        </ArgonTypography>
      ),
    }));

  // Get current entity type for display
  const getCurrentEntityType = () => (mainTabValue === 0 ? "Parent" : "Tutor");
  const getCurrentEntityTypeLower = () => (mainTabValue === 0 ? "parent" : "tutor");

  // Drag handlers
  const handleDragStart = (e, item, studentData = null) => {
    setDraggedItem({ item, studentData });
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = async (e, newStatus) => {
    e.preventDefault();
    if (!draggedItem) return;

    const { item, studentData } = draggedItem;

    // If student-specific card is being moved
    if (studentData) {
      const statusKey = `${item._id}-${studentData._id}`;

      // Check if moving to OTM status
      if (newStatus === "OTM") {
        try {
          // Update student-level status on backend first
          const statusEndpoint = `/crm/${item._id}/student-status`;
          await api.put(statusEndpoint, {
            studentId: studentData._id,
            followUpStatus: newStatus,
          });

          // Update student-level status locally
          setStudentLevelStatuses((prev) => ({
            ...prev,
            [statusKey]: newStatus,
          }));

          // Initialize student level amounts for this specific student
          const initialAmounts = [
            {
              studentId: studentData._id,
              studentName: studentData.name,
              educationLevel: studentData.educationLevel || "N/A",
              levelAmount: 0,
            },
          ];

          // Show the popup for amount entry
          setCurrentOtmItem(item);
          setOtmAmount("");
          setPartialAmount("");
          setStudentLevelAmounts(initialAmounts);
          setOtmPopupOpen(true);
          setDraggedItem(null);
        } catch (err) {
          console.error("Error updating to OTM status:", err);
          toast.error("Failed to update to OTM status");
          setDraggedItem(null);
        }
        return;
      }

      try {
        // Update student-level status on backend
        const endpoint = `/crm/${item._id}/student-status`;

        console.log(
          "Updating student-level followUpStatus for:",
          item._id,
          "Student:",
          studentData._id,
          "Value:",
          newStatus
        );

        await api.put(endpoint, {
          studentId: studentData._id,
          followUpStatus: newStatus,
        });

        // Update local state
        setStudentLevelStatuses((prev) => ({
          ...prev,
          [statusKey]: newStatus,
        }));

        toast.success(`Status updated to ${newStatus} for ${studentData.name}`);
        fetchCRMData(); // Refresh data
        setDraggedItem(null);
      } catch (err) {
        console.error("Error updating student status:", err);
        console.error("Error response:", err.response?.data);

        // If backend doesn't support student-level status, fall back to local state only
        if (err.response?.status === 404 || err.response?.status === 400) {
          console.log("Backend doesn't support student-level status, using local state only");
          setStudentLevelStatuses((prev) => ({
            ...prev,
            [statusKey]: newStatus,
          }));
          toast.success(`Status updated to ${newStatus} for ${studentData.name} (local only)`);
        } else {
          toast.error(err.response?.data?.message || "Failed to update status");
        }
        setDraggedItem(null);
      }
      return;
    }

    // Original logic for combined parent cards or tutor cards
    // Check if moving to OTM status
    if (newStatus === "OTM") {
      // If no OTM amount exists, update status to OTM and open popup to add new entry
      if (!item.parentOTMAmount || item.parentOTMAmount <= 0) {
        try {
          // First update the status to OTM
          const statusEndpoint = `/crm/${item._id}/status`;
          await api.put(statusEndpoint, {
            followUpStatus: "OTM",
          });

          // Initialize student level amounts for all students in this parent
          const initialAmounts = [];
          if (item.parentId?.students) {
            item.parentId.students.forEach((student) => {
              initialAmounts.push({
                studentId: student._id,
                studentName: student.name,
                educationLevel: student.educationLevel || "N/A",
                levelAmount: 0,
              });
            });
          }

          // Show the popup for amount entry
          setCurrentOtmItem(item);
          setOtmAmount("");
          setPartialAmount("");
          setStudentLevelAmounts(initialAmounts);
          setOtmPopupOpen(true);
          setDraggedItem(null);
        } catch (err) {
          console.error("Error updating to OTM status:", err);
          toast.error(err.response?.data?.message || "Failed to update to OTM status");
          setDraggedItem(null);
        }
        return;
      }

      // If amount exists, just update the status
      try {
        const endpoint = `/crm/${item._id}/status`;
        await api.put(endpoint, {
          followUpStatus: "OTM",
        });
        toast.success("Status updated to OTM");
        fetchCRMData();
        setDraggedItem(null);
      } catch (err) {
        console.error("Error updating to OTM status:", err);
        toast.error(err.response?.data?.message || "Failed to update to OTM status");
        setDraggedItem(null);
      }
      return;
    }

    try {
      // Update followUpStatus in backend
      const endpoint = `/crm/${item._id}/status`;

      console.log("Updating followUpStatus for:", item._id, "Value:", newStatus);

      await api.put(endpoint, {
        followUpStatus: newStatus,
      });

      toast.success(`Status updated to ${newStatus}`);
      fetchCRMData(); // Refresh data
      setDraggedItem(null);
    } catch (err) {
      console.error("Error updating status:", err);
      console.error("Error response:", err.response?.data);
      toast.error(err.response?.data?.message || "Failed to update status");
      setDraggedItem(null);
    }
  };

  // Handle OTM amount submission
  const handleOtmAmountSubmit = async () => {
    if (!currentOtmItem || !otmAmount) {
      toast.error("Please enter a valid OTM amount");
      return;
    }

    const amount = parseFloat(otmAmount);
    if (isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid positive OTM amount");
      return;
    }

    const partial = partialAmount ? parseFloat(partialAmount) : 0;
    if (partialAmount && (isNaN(partial) || partial < 0)) {
      toast.error("Please enter a valid partial amount");
      return;
    }

    if (partial > amount) {
      toast.error("Partial amount cannot be greater than OTM amount");
      return;
    }

    try {
      const endpoint = `/crm/${currentOtmItem._id}/otm-amount`;

      // Prepare student level amounts for backend
      const studentAmountsPayload = studentLevelAmounts.map((sa) => ({
        studentId: sa.studentId,
        levelAmount: parseFloat(sa.levelAmount) || 0,
      }));

      console.log("Submitting OTM amount:", {
        id: currentOtmItem._id,
        amount: amount,
        partialAmount: partial,
        studentLevelAmounts: studentAmountsPayload,
      });

      const response = await api.put(endpoint, {
        amount: amount,
        partialAmount: partial,
        studentLevelAmounts: studentAmountsPayload,
      });

      console.log("OTM amount response:", response.data);

      toast.success("Amounts saved. Item remains in OTM status.");
      setOtmPopupOpen(false);
      setCurrentOtmItem(null);
      setOtmAmount("");
      setPartialAmount("");
      setStudentLevelAmounts([]);
      fetchCRMData(); // Refresh data
    } catch (err) {
      console.error("Error updating OTM amount:", err);
      console.error("Error response:", err.response?.data);
      const errorMessage =
        err.response?.data?.error || err.response?.data?.message || "Failed to update OTM amount";
      toast.error(errorMessage);
    }
  };

  // Calculate total amount for a specific status
  const calculateTotalAmountForStatus = (statusId) => {
    if (mainTabValue !== 0) return 0; // Only for parent CRM

    let total = 0;
    const itemsInStatus = groupedData[statusId] || [];
    itemsInStatus.forEach((item) => {
      if (item.type === "PARENT" && item.parentId?.students) {
        let subscriptionTotal = 0;
        item.parentId.students.forEach((student) => {
          if (student.currentSubscription?.amount) {
            subscriptionTotal += student.currentSubscription.amount;
          }
        });
        const otmAmount = item.parentOTMAmount || 0;

        // Add student level amounts to total
        let studentLevelTotal = 0;
        if (item.studentLevelAmounts && Array.isArray(item.studentLevelAmounts)) {
          item.studentLevelAmounts.forEach((sa) => {
            studentLevelTotal += parseFloat(sa.levelAmount) || 0;
          });
        }

        total += subscriptionTotal + otmAmount + studentLevelTotal;
      }
    });
    return total;
  };

  // Handle OTM popup close
  const handleOtmPopupClose = () => {
    setOtmPopupOpen(false);
    setCurrentOtmItem(null);
    setOtmAmount("");
    setPartialAmount("");
    setStudentLevelAmounts([]);
  };

  // Get current status array based on type
  const currentFollowUpStatuses =
    mainTabValue === 0 ? parentFollowUpStatuses : tutorFollowUpStatuses;
  const currentCRMType = mainTabValue === 0 ? "PARENT" : "TUTOR";

  // Helper function to get student-level status
  const getStudentStatus = (item, studentId) => {
    return getCRMStudentStatusValue(item, studentId, studentLevelStatuses);
  };

  // Group CRM data by followUpStatus with student-level support
  const groupedData = currentFollowUpStatuses.reduce((acc, status) => {
    acc[status.id] = [];

    if (Array.isArray(crmData)) {
      crmData.forEach((item) => {
        // For parent CRM with multiple students
        if (mainTabValue === 0 && item.parentId?.students?.length > 1) {
          const isCombined = combinedParents[item.parentId._id];

          if (isCombined) {
            // Combined view - check if parent's status matches
            if (item.followUpStatus === status.id) {
              acc[status.id].push(item);
            }
          } else {
            // Separated view - we'll add student-specific items later when rendering
            // For now, check if any student has this status
            const hasStudentWithStatus = item.parentId.students.some(
              (student) => getStudentStatus(item, student._id) === status.id
            );
            if (hasStudentWithStatus) {
              acc[status.id].push(item);
            }
          }
        } else {
          // For single student parents or tutor CRM
          if (item.followUpStatus === status.id) {
            acc[status.id].push(item);
          }
        }
      });
    }

    return acc;
  }, {});

  // Add items without followUpStatus to first status
  const itemsWithoutStatus = Array.isArray(crmData)
    ? crmData.filter((item) => {
        // For separated multi-student parents, check if any student lacks status
        if (
          mainTabValue === 0 &&
          item.parentId?.students?.length > 1 &&
          !combinedParents[item.parentId._id]
        ) {
          return item.parentId.students.some((student) => !getStudentStatus(item, student._id));
        }
        return !item.followUpStatus;
      })
    : [];
  if (itemsWithoutStatus.length > 0) {
    const firstStatusId = currentFollowUpStatuses[0]?.id;
    if (firstStatusId) {
      // Avoid duplicates
      const existingIds = new Set(groupedData[firstStatusId].map((i) => i._id));
      const newItems = itemsWithoutStatus.filter((i) => !existingIds.has(i._id));
      groupedData[firstStatusId] = [...(groupedData[firstStatusId] || []), ...newItems];
    }
  }

  const getKanbanCardsForStatus = (statusId, applySearch = true) => {
    const itemsInStatus = groupedData[statusId] || [];

    return getKanbanCardsFromItems(
      itemsInStatus,
      statusId,
      currentCRMType,
      combinedParents,
      studentLevelStatuses
    ).filter(({ item, studentData }) => !applySearch || matchesCRMSearch(
      mainTabValue === 0 ? item.parentId : item.tutorId, searchQuery, studentData
    ));
  };

  const firstMatchingStageId = searchQuery.trim()
    ? currentFollowUpStatuses.find((status) => getKanbanCardsForStatus(status.id).length > 0)?.id
    : null;

  useEffect(() => {
    if (viewMode !== "kanban" || !searchQuery.trim() || !firstMatchingStageId) return;
    const board = kanbanBoardRef.current;
    const stage = kanbanStageRefs.current[firstMatchingStageId];
    if (!board || !stage) return;

    // Scroll only the board so typing does not move the page or search input.
    board.scrollLeft += stage.getBoundingClientRect().left - board.getBoundingClientRect().left - 16;
    Object.values(kanbanCardListRefs.current).forEach((list) => {
      if (list) list.scrollTop = 0;
    });
  }, [searchQuery, firstMatchingStageId, mainTabValue, viewMode]);

  const currentKanbanBoardCount = currentFollowUpStatuses.reduce(
    (total, status) => total + getKanbanCardsForStatus(status.id, false).length,
    0
  );

  useEffect(() => {
    const countKey = mainTabValue === 0 ? "parent" : "tutor";
    setCrmBoardCounts((prevCounts) =>
      prevCounts[countKey] === currentKanbanBoardCount
        ? prevCounts
        : { ...prevCounts, [countKey]: currentKanbanBoardCount }
    );
  }, [currentKanbanBoardCount, mainTabValue]);

  // Toggle combine/separate view for a parent
  const toggleCombineView = (parentId) => {
    // Store the pending action and show confirmation dialog
    setPendingCombineAction(parentId);
    setCombineConfirmDialog(true);
  };

  // Confirm combine/separate action
  const handleConfirmCombineToggle = () => {
    if (pendingCombineAction) {
      setCombinedParents((prev) => ({
        ...prev,
        [pendingCombineAction]: !prev[pendingCombineAction],
      }));
    }
    setCombineConfirmDialog(false);
    setPendingCombineAction(null);
  };

  // Cancel combine/separate action
  const handleCancelCombineToggle = () => {
    setCombineConfirmDialog(false);
    setPendingCombineAction(null);
  };

  // Fetch shortlisted tutors for a parent
  const fetchShortlistedTutors = async (parentId) => {
    if (!parentId) return;

    try {
      setShortlistedLoading(true);
      const response = await api.get(`/shortlisted-tutors/parent?parentId=${parentId}`);

      if (response.data.success) {
        const tutorsWithId = (response.data.data || []).map((tutor) => ({
          ...tutor,
          _id: tutor.tutorId || tutor._id,
        }));
        setShortlistedTutors(tutorsWithId);
      } else {
        setShortlistedTutors([]);
      }
    } catch (err) {
      console.error("Error fetching shortlisted tutors:", err);
      setShortlistedTutors([]);
    } finally {
      setShortlistedLoading(false);
    }
  };

  // Fetch interested tutors from applied leads for a parent
  // Handle interested tutor checkbox toggle
  const handleInterestedTutorToggle = (tutorId) => {
    setSelectedInterestedTutors((prev) => {
      if (prev.includes(tutorId)) {
        return prev.filter((id) => id !== tutorId);
      } else {
        return [...prev, tutorId];
      }
    });
  };

  // Handle shortlisting selected interested tutors
  const handleShortlistSelected = async () => {
    if (!selectedDetailData?.userData?._id) {
      toast.error("Parent ID not found");
      return;
    }

    if (selectedInterestedTutors.length === 0) {
      toast.warning("Please select at least one tutor to shortlist");
      return;
    }

    try {
      setInterestedLoading(true);
      const response = await api.post("/shortlisted-tutors/save", {
        parentId: selectedDetailData.userData._id,
        tutorIds: selectedInterestedTutors,
      });

      if (response.data.success) {
        toast.success(response.data.message || "Tutors shortlisted successfully");
        // Refresh both lists
        await fetchShortlistedTutors(selectedDetailData.userData._id);
        await fetchInterestedTutors(selectedDetailData.userData._id);
        // Clear selection
        setSelectedInterestedTutors([]);
      }
    } catch (error) {
      console.error("Error shortlisting tutors:", error);
      toast.error(error.response?.data?.message || "Failed to shortlist tutors");
    } finally {
      setInterestedLoading(false);
    }
  };

  const fetchInterestedTutors = async (parentId) => {
    if (!parentId) return;

    try {
      setInterestedLoading(true);
      console.log("Fetching interested tutors for parent:", parentId);

      // Use the new backend endpoint that gets applied leads by parent
      const response = await api.get(`/applied-leads/parent?parentId=${parentId}`);

      console.log("Applied leads response:", response.data);

      if (response.data.success && response.data.data && response.data.data.length > 0) {
        const appliedLeads = response.data.data;

        // Get shortlisted tutor IDs to filter them out
        const shortlistedResponse = await api.get(
          `/shortlisted-tutors/parent?parentId=${parentId}`
        );
        const shortlistedTutorIds =
          shortlistedResponse.data.success && shortlistedResponse.data.data
            ? shortlistedResponse.data.data.map((st) => st._id.toString())
            : [];

        console.log("Shortlisted tutor IDs:", shortlistedTutorIds);

        // Format tutor data from applied leads and filter out shortlisted tutors
        const interestedTutorsList = appliedLeads
          .filter((appliedLead) => appliedLead.tutorId)
          .filter((appliedLead) =>
            ["APPLIED", "IN_REVIEW"].includes(appliedLead.status || "APPLIED")
          )
          .filter(
            (appliedLead) => !shortlistedTutorIds.includes(appliedLead.tutorId._id.toString())
          )
          .map((appliedLead) => {
            const tutorData = appliedLead.tutorId;
            console.log("Tutor Data:", {
              name: tutorData.fullName,
              experience: tutorData.experience,
              expectedSalary: tutorData.expectedSalary,
            });
            return {
              _id: tutorData._id,
              name: tutorData.fullName || tutorData.name || "N/A",
              gender: tutorData.gender || "N/A",
              subjects: tutorData.subjects?.map((s) => s.name || s).join(", ") || "All Subjects",
              classes: tutorData.classes?.map((c) => c.name || c).join(", ") || "N/A",
              boards: tutorData.boards?.map((b) => b.name || b).join(", ") || "N/A",
              experience:
                tutorData.experience !== undefined && tutorData.experience !== null
                  ? String(tutorData.experience)
                  : "0",
              priceRange: tutorData.expectedSalary ? `₹${tutorData.expectedSalary}/hr` : "Not Set",
              rating: tutorData.rating || { averageRating: 0, totalReviews: 0 },
              profileImage: tutorData.profileImage || tutorData.profileImg || null,
              source: "lead",
              appliedAt: appliedLead.createdAt,
            };
          });

        console.log("Formatted interested tutors (excluding shortlisted):", interestedTutorsList);
        setInterestedTutors(interestedTutorsList);
      } else {
        console.log("No interested tutors found");
        setInterestedTutors([]);
      }
    } catch (err) {
      console.error("Error fetching interested tutors:", err);
      console.error("Error details:", err.response?.data);
      setInterestedTutors([]);
    } finally {
      setInterestedLoading(false);
    }
  };

  const formatAppliedTutorsFromLeads = (appliedLeads = []) => {
    const uniqueTutors = new Map();

    appliedLeads.forEach((appliedLead) => {
      const tutorData = appliedLead?.tutorId;
      if (!tutorData?._id || uniqueTutors.has(tutorData._id)) {
        return;
      }

      uniqueTutors.set(tutorData._id, {
        _id: tutorData._id,
        name: tutorData.fullName || tutorData.name || "N/A",
        phone: tutorData.phone || "N/A",
        email: tutorData.email || "N/A",
        profileImage: tutorData.profileImage || tutorData.profileImg || tutorData.profile || "",
        appliedAt: appliedLead.createdAt,
        status: appliedLead.status || "APPLIED",
        notes:
          appliedLead?.notes ||
          appliedLead?.note ||
          appliedLead?.remarks ||
          appliedLead?.leadId?.notes ||
          "",
      });
    });

    return Array.from(uniqueTutors.values());
  };

  const formatShortlistedTutorsForPopup = (tutors = []) =>
    tutors
      .filter((tutor) => tutor?._id || tutor?.tutorId)
      .map((tutor) => ({
        _id: tutor._id || tutor.tutorId,
        name: tutor.name || tutor.fullName || "N/A",
        phone: tutor.phone || "N/A",
        email: tutor.email || "N/A",
        profileImage: tutor.profile || tutor.profileImg || tutor.profileImage || "",
        status: "IN_REVIEW",
        notes: tutor.notes || "Shortlisted for parent review",
      }));

  const buildAppliedTutorGroups = (appliedTutors = [], shortlistedTutorList = []) => {
    const groups = getEmptyAppliedTutorGroups();
    const addTutor = (groupKey, tutor) => {
      if (!tutor?._id || groups[groupKey].some((item) => item._id === tutor._id)) {
        return;
      }
      groups[groupKey].push(tutor);
    };

    appliedTutors.forEach((tutor) => {
      if (tutor.status === "SELECTED") {
        addTutor("confirmed", tutor);
      } else if (tutor.status === "CANCELLED") {
        addTutor("rejected", tutor);
      } else if (tutor.status === "IN_REVIEW") {
        addTutor("shortlisted", tutor);
      } else {
        addTutor("applied", tutor);
      }
    });

    shortlistedTutorList.forEach((tutor) => {
      const alreadyFinal = groups.confirmed.some((item) => item._id === tutor._id) ||
        groups.rejected.some((item) => item._id === tutor._id);
      if (!alreadyFinal) {
        addTutor("shortlisted", tutor);
      }
    });

    return groups;
  };
  const handleAppliedTutorsPopupClose = () => {
    setAppliedTutorsPopupOpen(false);
    setSelectedAppliedTutorGroups(getEmptyAppliedTutorGroups());
    setAppliedTutorStatusTab(0);
    setSelectedAppliedParentName("");
  };

  const handleAppliedTutorsClick = async (parentId, parentName) => {
    if (!parentId) {
      toast.error("Parent not found");
      return;
    }

    try {
      setAppliedTutorsPopupOpen(true);
      setAppliedTutorsPopupLoading(true);
      setSelectedAppliedParentName(parentName || "Parent");
      setAppliedTutorStatusTab(0);
      setSelectedAppliedTutorGroups(getEmptyAppliedTutorGroups());

      const [appliedResponse, shortlistedResponse] = await Promise.all([
        api.get(`/applied-leads/parent?parentId=${parentId}`),
        api.get(`/shortlisted-tutors/parent?parentId=${parentId}`),
      ]);

      const appliedLeads = appliedResponse.data?.success ? appliedResponse.data?.data || [] : [];
      const shortlistedList = shortlistedResponse.data?.success
        ? shortlistedResponse.data?.data || []
        : [];
      const formattedTutors = formatAppliedTutorsFromLeads(appliedLeads);
      const formattedShortlistedTutors = formatShortlistedTutorsForPopup(shortlistedList);
      const groupedTutors = buildAppliedTutorGroups(
        formattedTutors,
        formattedShortlistedTutors
      );
      const totalTutors = appliedTutorSections.reduce(
        (total, section) => total + groupedTutors[section.key].length,
        0
      );

      setSelectedAppliedTutorGroups(groupedTutors);
      setAppliedTutorCounts((prev) => ({
        ...prev,
        [parentId]: totalTutors,
      }));
    } catch (error) {
      console.error("Error fetching applied tutors:", error);
      toast.error(error.response?.data?.message || "Failed to fetch applied tutors");
      setSelectedAppliedTutorGroups(getEmptyAppliedTutorGroups());
    } finally {
      setAppliedTutorsPopupLoading(false);
    }
  };
  // Handle view detail click
  const isCRMItemUnread = (item) => {
    if (!item) return false;

    const expectedReason = mainTabValue === 0 ? "PARENT_ENQUIRY" : "TUTOR_APP_INSTALLED";
    return Boolean(
      (item.adminUnread && item.adminUnreadReason === expectedReason) ||
        item.isNewForAdmin
    );
  };

  const handleViewDetail = async (item, studentData = null) => {
    setDrawerOpen(true);
    setDetailLoading(true);
    try {
      const userData = mainTabValue === 0 ? item.parentId : item.tutorId;

      setSelectedDetailData({
        crmItem: item,
        userData: userData,
        studentData: studentData,
        type: mainTabValue === 0 ? "PARENT" : "TUTOR",
      });

      if (mainTabValue === 0 && userData?._id) {
        fetchShortlistedTutors(userData._id);
        fetchInterestedTutors(userData._id);
      }

      if (isCRMItemUnread(item)) {
        markCRMItemSeen(item._id);
      }
    } catch (err) {
      console.error("Error setting detail data:", err);
      toast.error("Failed to load details");
    } finally {
      setDetailLoading(false);
    }
  };

  // Close detail drawer
  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedDetailData(null);
    setShortlistedTutors([]);
    setInterestedTutors([]);
    setSelectedInterestedTutors([]);
  };

  // Render Kanban Card
  const renderKanbanCard = (item, studentData = null) => {
    const userData = mainTabValue === 0 ? item.parentId : item.tutorId;
    console.log(
      "Rendering card for:",
      mainTabValue === 0 ? "PARENT" : "TUTOR",
      "Item:",
      item,
      "UserData:",
      userData,
      "StudentData:",
      studentData
    );
    if (!userData) {
      console.warn("No userData found for item:", item);
      return null;
    }

    // Check if this parent has multiple students
    const hasMultipleStudents =
      mainTabValue === 0 && userData.students && userData.students.length > 1;
    const isCombined = combinedParents[userData._id];
    const isParentView = mainTabValue === 0;
    const appliedTutorCount = isParentView ? appliedTutorCounts[userData?._id] ?? 0 : 0;
    const isUnreadForAdmin = isCRMItemUnread(item);

    return (
      <Paper
        key={studentData ? `${item._id}-${studentData._id}` : item._id}
        draggable
        onDragStart={(e) => handleDragStart(e, item, studentData)}
        sx={{
          p: 2,
          mb: 1.5,
          cursor: "grab",
          transition: "all 0.2s ease",
          border: isUnreadForAdmin
            ? "2px solid #f5365c"
            : studentData
            ? "2px solid #5e72e4"
            : "1px solid #e0e0e0",
          boxShadow: isUnreadForAdmin ? "0 0 0 3px rgba(245, 54, 92, 0.12)" : "none",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: isUnreadForAdmin
              ? "0 6px 16px rgba(245, 54, 92, 0.22)"
              : "0 4px 12px rgba(0,0,0,0.15)",
          },
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <ArgonBox mb={1}>
          {/* Top Row: Combine + View */}
          <ArgonBox display="flex" justifyContent="flex-end" alignItems="center" gap={1} mb={0.5}>
            {hasMultipleStudents && (
              <ArgonButton
                variant="outlined"
                color={isCombined ? "success" : "info"}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCombineView(userData._id);
                }}
                sx={{
                  textTransform: "none",
                  fontSize: "0.65rem",
                  padding: "2px 8px",
                  minWidth: "auto",
                }}
              >
                {isCombined ? "Separate" : "Combine"}
              </ArgonButton>
            )}

            {isParentView && (
                <ArgonBox
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAppliedTutorsClick(userData?._id, userData?.fullName);
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.4,
                    padding: "4px 8px",
                    borderRadius: "999px",
                    backgroundColor: "rgba(94, 114, 228, 0.08)",
                    cursor: "pointer",
                    border: "1px solid rgba(94, 114, 228, 0.16)",
                    "&:hover": {
                      backgroundColor: "rgba(94, 114, 228, 0.15)",
                    },
                  }}
                >
                  <GroupsIcon sx={{ fontSize: 16, color: "#5e72e4" }} />
                  <ArgonTypography
                    variant="caption"
                    fontWeight="bold"
                    sx={{ lineHeight: 1, color: "#d32f2f" }}
                  >
                    {appliedTutorCount}
                  </ArgonTypography>
                </ArgonBox>
            )}

            <IconButton
              size="small"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleViewDetail(item, studentData);
              }}
              sx={{
                padding: "4px",
                color: isUnreadForAdmin ? "#f5365c" : "#5e72e4",
                backgroundColor: isUnreadForAdmin ? "rgba(245, 54, 92, 0.1)" : "transparent",
                "&:hover": {
                  backgroundColor: isUnreadForAdmin
                    ? "rgba(245, 54, 92, 0.18)"
                    : "rgba(94, 114, 228, 0.1)",
                },
              }}
            >
              <VisibilityIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </ArgonBox>

          {/* Bottom Row: Name + Student */}
          <ArgonBox>
            <ArgonTypography
              variant="button"
              fontWeight="bold"
              color="primary"
              onClick={() => {
                if (mainTabValue === 0) {
                  navigate(`/parents/profile/${userData._id}`);
                } else {
                  navigate(`/tutors/profile/${userData._id}`);
                }
              }}
              sx={{
                cursor: "pointer",
                textDecoration: "underline",
                "&:hover": {
                  color: "#1976d2",
                },
              }}
            >
              {userData.fullName || "N/A"}
            </ArgonTypography>

            {studentData && (
              <ArgonTypography variant="caption" color="info" display="block" fontWeight="bold">
                Student: {studentData.name}
              </ArgonTypography>
            )}

            {item.enquiryProductName && (
              <ArgonTypography variant="caption" fontWeight="bold" color="text" display="block">
                Product: {item.enquiryProductName}
              </ArgonTypography>
            )}
          </ArgonBox>
        </ArgonBox>

        <ArgonBox display="flex" flexDirection="column" gap={0.5}>
          <ArgonBox display="flex" alignItems="center" gap={0.5}>
            <PhoneIcon sx={{ fontSize: 14, color: "#8392ab" }} />
            <ArgonTypography variant="caption" color="text">
              {userData.phone || "N/A"}
            </ArgonTypography>
          </ArgonBox>
          <ArgonBox display="flex" alignItems="center" gap={0.5}>
            <EmailIcon sx={{ fontSize: 14, color: "#8392ab" }} />
            <ArgonTypography variant="caption" color="text">
              {userData.email || "N/A"}
            </ArgonTypography>
          </ArgonBox>
          {/* Location & Highest Qualification (for Tutor cards) */}
          {mainTabValue === 1 && (
            <>
              <ArgonBox display="flex" alignItems="center" gap={0.5}>
                <LocationOnIcon sx={{ fontSize: 14, color: "#8392ab" }} />
                <ArgonTypography variant="caption" color="text">
                  {(() => {
                    // First try to extract "Area:" from address field
                    if (userData.address && typeof userData.address === "string") {
                      const areaMatch = userData.address.match(/Area:\s*([^,]+)/);
                      if (areaMatch && areaMatch[1]) {
                        return areaMatch[1].trim();
                      }
                    }

                    // Fallback to locationPreference address (split by comma)
                    if (
                      Array.isArray(userData.locationPreference) &&
                      userData.locationPreference.length > 0 &&
                      userData.locationPreference[0]?.address
                    ) {
                      const locAddress = userData.locationPreference[0].address;
                      return locAddress.split(",")[0].trim();
                    }

                    return "N/A";
                  })()}
                </ArgonTypography>
              </ArgonBox>

              {/* Highest Qualification (First qualification from array) */}
              {Array.isArray(userData.educationQualification) &&
                userData.educationQualification.length > 0 && (
                  <ArgonBox display="flex" alignItems="center" gap={0.5}>
                    <SchoolIcon sx={{ fontSize: 14, color: "#8392ab" }} />
                    <ArgonTypography variant="caption" color="text">
                      {userData.educationQualification[0]?.class?.name ||
                        userData.educationQualification[0]?.class ||
                        "N/A"}
                    </ArgonTypography>
                  </ArgonBox>
                )}
            </>
          )}
        </ArgonBox>

        {/* Display OTM Amount if available */}
        {item.parentOTMAmount && item.parentOTMAmount > 0 && (
          <ArgonBox mt={1}>
            <ArgonTypography variant="caption" fontWeight="bold" color="success">
              OTM Amount: ₹{item.parentOTMAmount}
            </ArgonTypography>
          </ArgonBox>
        )}

        {/* Display Partial Amount if available */}
        {item.partialAmount && item.partialAmount > 0 && (
          <ArgonBox mt={1}>
            <ArgonTypography variant="caption" fontWeight="bold" color="warning">
              Partial Amount: ₹{item.partialAmount}
            </ArgonTypography>
          </ArgonBox>
        )}

        {/* Edit Button for OTM cards - Only show when amount exists */}
        {item.followUpStatus === "OTM" && item.parentOTMAmount && item.parentOTMAmount > 0 && (
          <ArgonBox mt={1.5}>
            <ArgonButton
              variant="gradient"
              color="warning"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                // Pre-fill existing amounts for update
                const students = item.parentId?.students || [];
                const existingStudentAmounts = item.studentLevelAmounts || [];

                const initialAmounts = students.map((student) => {
                  const existingAmount = existingStudentAmounts.find(
                    (sa) => sa.studentId === student._id
                  );
                  return {
                    studentId: student._id,
                    studentName: student.name,
                    educationLevel: student.class?.name || student.educationLevel || "N/A",
                    levelAmount: existingAmount?.levelAmount || 0,
                  };
                });

                setCurrentOtmItem(item);
                setOtmAmount(item.parentOTMAmount.toString());
                setPartialAmount(item.partialAmount ? item.partialAmount.toString() : "");
                setStudentLevelAmounts(initialAmounts);
                setOtmPopupOpen(true);
              }}
              sx={{
                textTransform: "none",
                fontSize: "0.7rem",
                padding: "4px 12px",
              }}
            >
              Edit Amounts
            </ArgonButton>
          </ArgonBox>
        )}

        {/* Display Student Level Amounts if available */}
        {item.studentLevelAmounts &&
          item.studentLevelAmounts.length > 0 &&
          (() => {
            // Calculate total of all student level amounts
            const totalAmount = item.studentLevelAmounts.reduce(
              (sum, sa) => sum + (sa.levelAmount || 0),
              0
            );

            return (
              <ArgonBox
                mt={1.5}
                sx={{
                  p: 1.5,
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  background: "#f8f9fa",
                }}
              >
                <ArgonBox mb={1}>
                  {/* Total Row */}
                  <ArgonBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={0.5}
                  >
                    <ArgonTypography variant="caption" fontWeight="bold" color="text">
                      Total:
                    </ArgonTypography>

                    <ArgonTypography
                      variant="caption"
                      fontWeight="bold"
                      color="success"
                      sx={{
                        background: "white",
                        padding: "2px 14px",
                        borderRadius: "4px",
                        border: "1px solid #28a745",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₹{totalAmount}
                    </ArgonTypography>
                  </ArgonBox>

                  {/* Student Level Pricing */}
                  <ArgonTypography variant="caption" fontWeight="bold" color="primary">
                    Student Level Pricing
                  </ArgonTypography>
                </ArgonBox>

                {item.studentLevelAmounts.map((sa) => {
                  // Find student details from parentId.students
                  const student = item.parentId?.students?.find((s) => s._id === sa.studentId);
                  return (
                    <ArgonBox
                      key={sa.studentId}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        p: 1,
                        mb: 0.5,
                        background: "white",
                        borderRadius: "4px",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      <ArgonTypography variant="caption" fontWeight="medium" color="text">
                        {student?.name || "Unknown Student"}
                      </ArgonTypography>
                      <ArgonTypography variant="caption" fontWeight="bold" color="success">
                        ₹{sa.levelAmount || 0}
                      </ArgonTypography>
                    </ArgonBox>
                  );
                })}
              </ArgonBox>
            );
          })()}

        {/* {item.lastStatusUpdated && (
          <ArgonTypography variant="caption" color="text" display="block" mt={1}>
            Updated: {new Date(item.lastStatusUpdated).toLocaleDateString()}
          </ArgonTypography>
        )} */}
      </Paper>
    );
  };

  const selectedAppliedTutorTotal = appliedTutorSections.reduce(
    (total, section) => total + (selectedAppliedTutorGroups[section.key]?.length || 0),
    0
  );

  const renderAppliedTutorSection = (section) => {
    const tutors = selectedAppliedTutorGroups[section.key] || [];

    return (
      <ArgonBox
        key={section.key}
        sx={{
          border: "1px solid rgba(148, 163, 184, 0.18)",
          borderRadius: "14px",
          backgroundColor: "#fff",
          overflow: "hidden",
          boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
        }}
      >
        <ArgonBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={1}
          sx={{
            px: 2,
            py: 1.4,
            backgroundColor: "#f8faff",
            borderBottom: "1px solid rgba(148, 163, 184, 0.16)",
          }}
        >
          <ArgonBox minWidth={0}>
            <ArgonTypography variant="button" color="dark" fontWeight="bold" display="block">
              {section.label}
            </ArgonTypography>
            <ArgonTypography variant="caption" color="text">
              {section.caption}
            </ArgonTypography>
          </ArgonBox>
          <Chip
            label={tutors.length}
            size="small"
            sx={{
              minWidth: 34,
              borderRadius: "999px",
              backgroundColor: section.bg,
              color: section.color,
              fontWeight: 800,
            }}
          />
        </ArgonBox>

        {tutors.length > 0 ? (
          <ArgonBox display="flex" flexDirection="column" gap={1} sx={{ p: 1.25 }}>
            {tutors.map((tutor) => (
              <ArgonBox
                key={`${section.key}-${tutor._id}`}
                display="flex"
                gap={1.25}
                sx={{
                  p: 1.25,
                  border: "1px solid rgba(226, 232, 240, 0.95)",
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderColor: section.color,
                    backgroundColor: "#fbfdff",
                  },
                }}
              >
                <Avatar
                  src={tutor.profileImage}
                  alt={tutor.name}
                  sx={{
                    width: 42,
                    height: 42,
                    background: `linear-gradient(135deg, ${section.color} 0%, #11cdef 100%)`,
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    flexShrink: 0,
                  }}
                >
                  {tutor.name?.charAt(0)?.toUpperCase() || "T"}
                </Avatar>

                <ArgonBox minWidth={0} flex={1}>
                  <ArgonBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                    <ArgonTypography
                      variant="button"
                      fontWeight="bold"
                      color="primary"
                      onClick={() => {
                        handleAppliedTutorsPopupClose();
                        navigate(`/tutors/profile/${tutor._id}`);
                      }}
                      sx={{
                        cursor: "pointer",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        "&:hover": { textDecoration: "underline" },
                      }}
                      title={tutor.name}
                    >
                      {tutor.name}
                    </ArgonTypography>
                    <Chip
                      label={section.label}
                      size="small"
                      sx={{
                        height: 22,
                        borderRadius: "999px",
                        backgroundColor: section.bg,
                        color: section.color,
                        fontSize: "0.68rem",
                        fontWeight: 800,
                        flexShrink: 0,
                      }}
                    />
                  </ArgonBox>

                  <ArgonBox display="flex" flexWrap="wrap" gap={1.2} mt={0.45}>
                    <ArgonBox display="flex" alignItems="center" gap={0.4}>
                      <PhoneIcon sx={{ fontSize: 13, color: "#8392ab" }} />
                      <ArgonTypography variant="caption" color="text">
                        {tutor.phone || "N/A"}
                      </ArgonTypography>
                    </ArgonBox>
                    {tutor.email && tutor.email !== "N/A" && (
                      <ArgonBox display="flex" alignItems="center" gap={0.4}>
                        <EmailIcon sx={{ fontSize: 13, color: "#8392ab" }} />
                        <ArgonTypography variant="caption" color="text">
                          {tutor.email}
                        </ArgonTypography>
                      </ArgonBox>
                    )}
                  </ArgonBox>

                  <ArgonTypography
                    variant="caption"
                    sx={{
                      display: "block",
                      mt: 0.75,
                      color: tutor.notes ? "#4a5568" : "#94a3b8",
                      lineHeight: 1.45,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {tutor.notes || "No note added"}
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            ))}
          </ArgonBox>
        ) : (
          <ArgonBox sx={{ px: 2, py: 2.2, textAlign: "center", backgroundColor: "#fff" }}>
            <ArgonTypography variant="caption" color="text">
              No {section.label.toLowerCase()} tutors
            </ArgonTypography>
          </ArgonBox>
        )}
      </ArgonBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox px={3} pt={3} pb={1}>
              <ArgonBox
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={2}
                flexWrap="wrap"
                gap={2}
              >
                <ArgonTypography variant="h6" fontWeight="medium">
                  CRM Management
                </ArgonTypography>
                <ArgonBox display="flex" gap={1} flexWrap="wrap">
                  {/* View Toggle Buttons */}
                  <ArgonButton
                    variant={viewMode === "table" ? "contained" : "outlined"}
                    color="info"
                    size="small"
                    onClick={() => setViewMode("table")}
                    startIcon={<ViewListIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: "medium",
                      minWidth: "100px",
                    }}
                  >
                    Table
                  </ArgonButton>
                  <ArgonButton
                    variant={viewMode === "kanban" ? "contained" : "outlined"}
                    color="info"
                    size="small"
                    onClick={() => setViewMode("kanban")}
                    startIcon={<ViewKanbanIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: "medium",
                      minWidth: "100px",
                    }}
                  >
                    Kanban
                  </ArgonButton>
                  <ArgonButton
                    variant="gradient"
                    color="info"
                    size="small"
                    onClick={() => {
                      setRefresh((prev) => prev + 1);
                      fetchCRMData();
                    }}
                    disabled={loading}
                    startIcon={
                      loading ? (
                        <CircularProgress size={16} sx={{ color: "white" }} />
                      ) : (
                        <RefreshIcon />
                      )
                    }
                    sx={{
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: "medium",
                      minWidth: "140px",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: loading ? "none" : "translateY(-2px)",
                        boxShadow: loading ? "none" : "0 4px 12px rgba(94, 114, 228, 0.4)",
                      },
                      "&:active": {
                        transform: loading ? "none" : "translateY(0)",
                      },
                      "&.Mui-disabled": {
                        opacity: 0.7,
                        cursor: "not-allowed",
                      },
                    }}
                  >
                    {loading ? "Refreshing..." : "Refresh Data"}
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>

              {/* Main Tabs for Parent/Tutor */}
              <ArgonBox>
                <Tabs
                  value={mainTabValue}
                  onChange={handleMainTabChange}
                  sx={{
                    "& .MuiTabs-root": {
                      minHeight: "44px",
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#5e72e4",
                      height: "3px",
                      borderRadius: "3px 3px 0 0",
                    },
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                      minHeight: "44px",
                      padding: "12px 24px",
                      margin: "0 4px",
                      borderRadius: "8px 8px 0 0",
                      transition: "all 0.3s ease",
                      color: "#8392ab",
                      "&:hover": {
                        backgroundColor: "rgba(94, 114, 228, 0.1)",
                        color: "#5e72e4",
                      },
                    },
                    "& .Mui-selected": {
                      color: "#5e72e4 !important",
                      backgroundColor: "rgba(94, 114, 228, 0.1)",
                      fontWeight: "700",
                    },
                  }}
                >
                  <Tab
                    label={
                      <ArgonBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        flexWrap="wrap"
                      >
                        <ArgonTypography variant="button" fontWeight="inherit">
                          Parent CRM
                        </ArgonTypography>
                        {renderTabTotalCount(
                          mainTabValue === 0 ? currentKanbanBoardCount : crmBoardCounts.parent
                        )}
                        {renderTabNewCount(crmNewCounts.parentNewCount)}
                      </ArgonBox>
                    }
                  />
                  <Tab
                    label={
                      <ArgonBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        flexWrap="wrap"
                      >
                        <ArgonTypography variant="button" fontWeight="inherit">
                          Tutor CRM
                        </ArgonTypography>
                        {renderTabTotalCount(
                          mainTabValue === 1 ? currentKanbanBoardCount : crmBoardCounts.tutor
                        )}
                        {renderTabNewCount(crmNewCounts.tutorNewCount)}
                      </ArgonBox>
                    }
                  />
                </Tabs>
              </ArgonBox>
            </ArgonBox>

            {/* Conditional rendering based on view mode */}
            <ArgonBox px={3} pb={2} display="flex" alignItems="center" justifyContent="flex-end">
              <ArgonBox sx={{ width: 220, maxWidth: "100%" }}>
                <ArgonInput
                  placeholder={mainTabValue === 0 ? "search parents..." : "search tutors..."}
                  name="search"
                  size="small"
                  type="text"
                  variant="outlined"
                  inputProps={{ "aria-label": mainTabValue === 0 ? "Search parent, student or phone" : "Search tutor or phone" }}
                  value={searchQuery}
                  onChange={(event) => setSearchQueries((previous) => ({ ...previous, [mainTabValue]: event.target.value }))}
                />
              </ArgonBox>
            </ArgonBox>
            {viewMode === "table" ? (
              <ArgonBox
                sx={{
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                        `${borderWidth[1]} solid ${borderColor}`,
                    },
                  },
                }}
              >
                <ArgonBox px={3} pb={2}>
                  <ApnaTabs
                    tabsData={tabsData}
                    activeTab={statusFilter}
                    onTabChange={handleStatusChange}
                  />
                </ArgonBox>
                {loading || currentData.loading ? (
                  <ArgonBox display="flex" justifyContent="center" py={4}>
                    <CircularProgress size={28} aria-label="Loading CRM table" />
                  </ArgonBox>
                ) : filteredTableRows.length > 0 ? (
                  <Table columns={columns} rows={filteredTableRows} />
                ) : (
                  <ArgonBox textAlign="center" py={4}>
                    <ArgonTypography variant="h6" color="text" fontWeight="medium">
                      No {getCurrentEntityTypeLower()}s found
                    </ArgonTypography>
                    <ArgonTypography variant="button" color="text">
                      {searchQuery.trim() ? "No matching records. Try another name or phone number." : statusFilter === "All"
                        ? "Data will appear here when available"
                        : `No ${getCurrentEntityTypeLower()}s match the ${statusFilter} CRM stage`}
                    </ArgonTypography>
                  </ArgonBox>
                )}
              </ArgonBox>
            ) : (
              /* Kanban View */
              <ArgonBox
                ref={kanbanBoardRef}
                sx={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  px: 2,
                  pb: 3,
                  // Move scrollbar to top
                  transform: "rotateX(180deg)",
                  "&::-webkit-scrollbar": {
                    height: "10px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#C1C1C1",
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: "#b2b1b1ff",
                    },
                  },
                }}
              >
                <ArgonBox
                  display="flex"
                  gap={2}
                  sx={{
                    minWidth: "max-content",
                    // Reverse the rotation for content
                    transform: "rotateX(180deg)",
                  }}
                >
                  {currentFollowUpStatuses.map((status) => (
                    <ArgonBox
                      key={status.id}
                      ref={(node) => { kanbanStageRefs.current[status.id] = node; }}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, status.id)}
                      sx={{
                        minWidth: 280,
                        maxWidth: 280,
                        backgroundColor: "#f8f9fa",
                        borderRadius: 2,
                        p: 2,
                      }}
                    >
                      {/* Column Header */}
                      <ArgonBox
                        sx={{
                          backgroundColor: status.color,
                          borderRadius: 1.5,
                          p: 1.5,
                          mb: 2,
                        }}
                      >
                        <ArgonTypography
                          variant="button"
                          fontWeight="bold"
                          color="white"
                          sx={{
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          {status.label}
                        </ArgonTypography>
                        <ArgonTypography
                          variant="caption"
                          color="white"
                          sx={{
                            display: "block",
                            textAlign: "center",
                            opacity: 0.9,
                          }}
                        >
                          {getKanbanCardsForStatus(status.id).length} items
                          {mainTabValue === 0 && !searchQuery.trim() && calculateTotalAmountForStatus(status.id) > 0 && (
                            <div style={{ marginTop: "4px" }}>
                              Total Amount - ₹{calculateTotalAmountForStatus(status.id)}
                            </div>
                          )}
                        </ArgonTypography>
                      </ArgonBox>

                      {/* Cards Container */}
                      <ArgonBox
                        ref={(node) => { kanbanCardListRefs.current[status.id] = node; }}
                        sx={{
                          minHeight: 400,
                          maxHeight: 600,
                          overflowY: "auto",
                          "&::-webkit-scrollbar": {
                            width: "6px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#cbd5e0",
                            borderRadius: "3px",
                          },
                        }}
                      >
                        {getKanbanCardsForStatus(status.id).length > 0 ? (
                          getKanbanCardsForStatus(status.id).map(({ key, item, studentData }) => (
                            <Fragment key={key}>{renderKanbanCard(item, studentData)}</Fragment>
                          ))
                        ) : (
                          <ArgonBox
                            textAlign="center"
                            py={4}
                            sx={{
                              backgroundColor: "white",
                              borderRadius: 2,
                              border: "2px dashed #e2e8f0",
                            }}
                          >
                            <ArgonTypography variant="caption" color="text">
                              Drag items here
                            </ArgonTypography>
                          </ArgonBox>
                        )}
                      </ArgonBox>
                    </ArgonBox>
                  ))}
                </ArgonBox>
              </ArgonBox>
            )}
          </Card>
        </ArgonBox>

        {/* OTM Amount Popup */}
        <Dialog
          open={otmPopupOpen}
          onClose={handleOtmPopupClose}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 2,
              padding: 1,
            },
          }}
        >
          <DialogTitle sx={{ pb: 1, position: "relative" }}>
            <ArgonTypography variant="h6" fontWeight="bold" color="text">
              Enter OTM and Student Level Amounts
            </ArgonTypography>
            <IconButton
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
              onClick={handleOtmPopupClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ py: 3, px: 3 }}>
            <ArgonBox display="flex" flexDirection="column" gap={3}>
              {/* Student Level Amounts Section */}
              {studentLevelAmounts.length > 0 && (
                <ArgonBox
                  sx={{
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    background: "#f9f9f9",
                  }}
                >
                  <ArgonTypography variant="body2" fontWeight="bold" color="text" sx={{ mb: 2 }}>
                    Student Level Pricing
                  </ArgonTypography>
                  {studentLevelAmounts.map((student, index) => (
                    <ArgonBox
                      key={student.studentId}
                      sx={{
                        p: 2,
                        mb: 2,
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        background: "white",
                      }}
                    >
                      <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                        <ArgonBox>
                          <ArgonTypography variant="body2" fontWeight="medium" color="text">
                             {student.studentName}
                          </ArgonTypography>
                          <ArgonTypography variant="caption" color="text">
                            Class: {student.educationLevel}
                          </ArgonTypography>
                        </ArgonBox>
                        <ArgonBox width="40%">
                          <ArgonInput
                            type="number"
                            value={student.levelAmount}
                            onChange={(e) => {
                              const updated = [...studentLevelAmounts];
                              updated[index].levelAmount = e.target.value;
                              setStudentLevelAmounts(updated);
                            }}
                            placeholder="Amount (₹)"
                            inputProps={{ min: 0, step: "0.01" }}
                            size="small"
                          />
                        </ArgonBox>
                      </ArgonBox>
                    </ArgonBox>
                  ))}
                </ArgonBox>
              )}

              <ArgonBox>
                <ArgonTypography variant="body2" fontWeight="medium" color="text" sx={{ mb: 1 }}>
                  Partial Amount (₹)
                </ArgonTypography>
                <ArgonInput
                  type="number"
                  value={partialAmount}
                  onChange={(e) => setPartialAmount(e.target.value)}
                  placeholder="Enter partial amount in rupees"
                  inputProps={{ min: 0, step: "0.01" }}
                />
              </ArgonBox>
              <ArgonBox>
                <ArgonTypography variant="body2" fontWeight="medium" color="text" sx={{ mb: 1 }}>
                  Total Amount (₹)
                </ArgonTypography>
                <ArgonInput
                  type="number"
                  value={otmAmount}
                  onChange={(e) => setOtmAmount(e.target.value)}
                  placeholder="Enter Total amount in rupees"
                  inputProps={{ min: 0, step: "0.01" }}
                />
              </ArgonBox>
            </ArgonBox>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2, justifyContent: "flex-end" }}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleOtmPopupClose}
              sx={{ mr: 2 }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              variant="gradient"
              color="info"
              onClick={handleOtmAmountSubmit}
              disabled={!otmAmount || parseFloat(otmAmount) <= 0}
            >
              Save Amounts
            </ArgonButton>
          </DialogActions>
        </Dialog>

        {/* dialog popup */}
        <DeleteDialog
          open={deleteDialog}
          onClose={handleCloseDialog}
          onConfirm={handleCloseDialog}
          title={`Delete ${getCurrentEntityType()}`}
          description={`Are you sure you want to delete this ${getCurrentEntityTypeLower()}?`}
          confirmText={`Delete ${getCurrentEntityType()}`}
          cancelText="Cancel"
        />

        <Dialog
          open={appliedTutorsPopupOpen}
          onClose={handleAppliedTutorsPopupClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(15, 23, 42, 0.22)",
              background:
                "linear-gradient(180deg, rgba(247,250,255,1) 0%, rgba(255,255,255,1) 42%)",
            },
          }}
        >
          <DialogTitle sx={{ p: 0 }}>
            <ArgonBox
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              sx={{
                px: 2.5,
                py: 2.25,
                background: "linear-gradient(135deg, #eef4ff 0%, #f9fbff 100%)",
                borderBottom: "1px solid rgba(94, 114, 228, 0.12)",
              }}
            >
              <ArgonBox>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.75}>
                  <ArgonBox
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 10px 20px rgba(94, 114, 228, 0.22)",
                    }}
                  >
                    <GroupsIcon sx={{ color: "#fff", fontSize: 22 }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="bold" color="dark">
                      Applied Tutors
                    </ArgonTypography>
                    <ArgonTypography variant="caption" color="text" fontWeight="medium">
                      {selectedAppliedParentName || "Parent Lead"}
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>

                <Chip
                  label={`${selectedAppliedTutorTotal} Tutor${
                    selectedAppliedTutorTotal === 1 ? "" : "s"
                  }`}
                  size="small"
                  sx={{
                    mt: 0.5,
                    borderRadius: "999px",
                    backgroundColor: "rgba(244, 67, 54, 0.12)",
                    color: "#d32f2f",
                    fontWeight: 700,
                  }}
                />
              </ArgonBox>
              <IconButton
                onClick={handleAppliedTutorsPopupClose}
                sx={{
                  mt: 0.5,
                  backgroundColor: "rgba(255,255,255,0.85)",
                  border: "1px solid rgba(148, 163, 184, 0.22)",
                  "&:hover": {
                    backgroundColor: "#fff",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </ArgonBox>
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              px: 2.5,
              py: 2,
              borderTop: "none",
              borderBottom: "none",
            }}
          >
            {appliedTutorsPopupLoading ? (
              <ArgonBox display="flex" flexDirection="column" alignItems="center" py={5} gap={1}>
                <CircularProgress size={30} />
                <ArgonTypography variant="caption" color="text">
                  Loading applied tutors...
                </ArgonTypography>
              </ArgonBox>
            ) : selectedAppliedTutorTotal > 0 ? (
              <ArgonBox
                sx={{
                  border: "1px solid rgba(94, 114, 228, 0.14)",
                  borderRadius: "16px",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  boxShadow: "0 10px 26px rgba(15, 23, 42, 0.06)",
                }}
              >
                <Tabs
                  value={appliedTutorStatusTab}
                  onChange={(event, newValue) => setAppliedTutorStatusTab(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    minHeight: 52,
                    px: 1,
                    backgroundColor: "#f8faff",
                    borderBottom: "1px solid rgba(148, 163, 184, 0.16)",
                    "& .MuiTabs-indicator": {
                      height: 3,
                      borderRadius: "999px 999px 0 0",
                      backgroundColor: appliedTutorSections[appliedTutorStatusTab]?.color || "#5e72e4",
                    },
                    "& .MuiTab-root": {
                      minHeight: 52,
                      px: 1.5,
                      textTransform: "none",
                    },
                  }}
                >
                  {appliedTutorSections.map((section) => {
                    const count = selectedAppliedTutorGroups[section.key]?.length || 0;

                    return (
                      <Tab
                        key={section.key}
                        label={
                          <ArgonBox display="flex" alignItems="center" gap={0.8}>
                            <ArgonTypography
                              variant="caption"
                              fontWeight="bold"
                              sx={{ color: section.color, letterSpacing: 0 }}
                            >
                              {section.label}
                            </ArgonTypography>
                            <Chip
                              label={count}
                              size="small"
                              sx={{
                                height: 22,
                                minWidth: 28,
                                borderRadius: "999px",
                                backgroundColor: section.bg,
                                color: section.color,
                                fontSize: "0.72rem",
                                fontWeight: 800,
                              }}
                            />
                          </ArgonBox>
                        }
                      />
                    );
                  })}
                </Tabs>

                <ArgonBox sx={{ p: { xs: 1.25, sm: 1.75 }, backgroundColor: "#fbfdff" }}>
                  {renderAppliedTutorSection(
                    appliedTutorSections[appliedTutorStatusTab] || appliedTutorSections[0]
                  )}
                </ArgonBox>
              </ArgonBox>
            ) : (
              <ArgonBox
                textAlign="center"
                py={5}
                px={2}
                sx={{
                  border: "1px dashed rgba(148, 163, 184, 0.45)",
                  borderRadius: "18px",
                  backgroundColor: "rgba(248, 250, 252, 0.9)",
                }}
              >
                <ArgonBox
                  sx={{
                    width: 58,
                    height: 58,
                    margin: "0 auto 12px",
                    borderRadius: "18px",
                    backgroundColor: "rgba(94, 114, 228, 0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GroupsIcon sx={{ color: "#5e72e4", fontSize: 28 }} />
                </ArgonBox>
                <ArgonTypography variant="button" color="dark" fontWeight="bold" display="block">
                  No tutor has applied yet
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text">
                  Jab tutor apply karega, uski list yahan dikhegi.
                </ArgonTypography>
              </ArgonBox>
            )}
          </DialogContent>
        </Dialog>

        {/* Detail View Drawer */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={handleCloseDrawer}
          sx={{
            "& .MuiDrawer-paper": {
              width: { xs: "100%", sm: "500px", md: "600px" },
              maxWidth: "100%",
            },
          }}
        >
          {detailLoading ? (
            <ArgonBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
              <CircularProgress />
            </ArgonBox>
          ) : selectedDetailData ? (
            <ArgonBox>
              {/* Drawer Header */}
              <ArgonBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                sx={{
                  backgroundColor: "#5e72e4",
                  color: "white",
                }}
              >
                <ArgonBox>
                  <ArgonTypography variant="h5" color="white" fontWeight="bold">
                    {selectedDetailData.studentData
                      ? `Student Details - ${selectedDetailData.studentData.name}`
                      : selectedDetailData.type === "PARENT"
                      ? "Parent & Students Details"
                      : "Tutor Details"}
                  </ArgonTypography>
                  <ArgonTypography variant="caption" color="white" sx={{ opacity: 0.9 }}>
                    Complete Information
                  </ArgonTypography>
                </ArgonBox>
                <IconButton
                  onClick={handleCloseDrawer}
                  sx={{
                    "& svg": {
                      color: "#fff !important",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </ArgonBox>

              {/* Drawer Content */}
              <ArgonBox p={3} sx={{ overflowY: "auto", maxHeight: "calc(100vh - 100px)" }}>
                {/* If specific student is selected, show only student details */}
                {selectedDetailData.studentData ? (
                  <>
                    {/* Student Information */}
                    <ArgonBox
                      mb={3}
                      p={3}
                      sx={{
                        border: "2px solid #5e72e4",
                        borderRadius: "12px",
                        backgroundColor: "rgba(94, 114, 228, 0.05)",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" mb={2}>
                        <PersonIcon sx={{ mr: 1, color: "#5e72e4", fontSize: 28 }} />
                        <ArgonTypography variant="h5" fontWeight="bold" color="text">
                          {selectedDetailData.studentData.name}
                        </ArgonTypography>
                      </ArgonBox>

                      <List dense>
                        {/* Class/Education Level */}
                        {selectedDetailData.studentData.class && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Class"
                                secondary={
                                  typeof selectedDetailData.studentData.class === "object"
                                    ? selectedDetailData.studentData.class.name
                                    : selectedDetailData.studentData.class
                                }
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Board */}
                        {selectedDetailData.studentData.board && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Board"
                                secondary={
                                  typeof selectedDetailData.studentData.board === "object"
                                    ? selectedDetailData.studentData.board.name
                                    : selectedDetailData.studentData.board
                                }
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Subjects */}
                        {selectedDetailData.studentData.subjects &&
                          selectedDetailData.studentData.subjects.length > 0 && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary=" Subjects"
                                  secondary={selectedDetailData.studentData.subjects
                                    .map((s) => (typeof s === "object" ? s.name : s))
                                    .join(", ")}
                                  primaryTypographyProps={{
                                    fontSize: "0.875rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{
                                    fontSize: "1rem",
                                    fontWeight: "medium",
                                    color: "#344767",
                                  }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}

                        {/* Gender */}
                        {selectedDetailData.studentData.gender && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Student Gender"
                                secondary={selectedDetailData.studentData.gender}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Tutor Gender Preference */}
                        {selectedDetailData.studentData.tutorGenderPreference && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Tutor Gender Preference"
                                secondary={selectedDetailData.studentData.tutorGenderPreference}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Mode of Tuition */}
                        {selectedDetailData.studentData.modeOfTuition && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Mode of Tuition"
                                secondary={selectedDetailData.studentData.modeOfTuition}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Tuition Type */}
                        {selectedDetailData.studentData.tuitionType && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Tuition Type"
                                secondary={
                                  selectedDetailData.studentData.tuitionType === "SHORT_TERM"
                                    ? "Short Term"
                                    : "Long Term"
                                }
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* School Name */}
                        {selectedDetailData.studentData.schoolName && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" School Name"
                                secondary={selectedDetailData.studentData.schoolName}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Classes Per Week */}
                        {selectedDetailData.studentData.noOfClassesPerWeek && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Classes Per Week"
                                secondary={`${selectedDetailData.studentData.noOfClassesPerWeek} days a week`}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Preferred Time Duration */}
                        {selectedDetailData.studentData.preferredTimeDuration && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Class Duration"
                                secondary={`${
                                  selectedDetailData.studentData.preferredTimeDuration
                                } minutes (${(
                                  selectedDetailData.studentData.preferredTimeDuration / 60
                                ).toFixed(1)} hours)`}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1rem",
                                  fontWeight: "medium",
                                  color: "#344767",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Time Slot Preference */}
                        {selectedDetailData.studentData.slotPreferred &&
                          selectedDetailData.studentData.slotPreferred.length > 0 && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary=" Preferred Time Slots"
                                  secondary={
                                    selectedDetailData.studentData.slotPreferred
                                      .map((slot) => {
                                        if (typeof slot === "object") {
                                          return `${slot.startTime || slot.start || ""} - ${
                                            slot.endTime || slot.end || ""
                                          }`;
                                        }
                                        return slot;
                                      })
                                      .filter(Boolean)
                                      .join(", ") || "N/A"
                                  }
                                  primaryTypographyProps={{
                                    fontSize: "0.875rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{
                                    fontSize: "1rem",
                                    fontWeight: "medium",
                                    color: "#344767",
                                  }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}

                        {/* Subscription */}
                        {selectedDetailData.studentData.currentSubscription && (
                          <>
                            <ListItem>
                              <ListItemText
                                primary=" Subscription Amount"
                                secondary={`${
                                  selectedDetailData.studentData.currentSubscription.amount || 0
                                }`}
                                primaryTypographyProps={{
                                  fontSize: "0.875rem",
                                  fontWeight: "bold",
                                }}
                                secondaryTypographyProps={{
                                  fontSize: "1.2rem",
                                  color: "green",
                                  fontWeight: "bold",
                                }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )}

                        {/* Student Level Amount - OTM */}
                        {selectedDetailData.crmItem?.studentLevelAmounts &&
                          (() => {
                            const studentAmount =
                              selectedDetailData.crmItem.studentLevelAmounts.find(
                                (sa) => sa.studentId === selectedDetailData.studentData._id
                              );
                            return studentAmount && studentAmount.levelAmount > 0 ? (
                              <>
                                <ListItem>
                                  <ListItemText
                                    primary=" Student Level Amount (OTM)"
                                    secondary={`₹${studentAmount.levelAmount || 0}`}
                                    primaryTypographyProps={{
                                      fontSize: "0.875rem",
                                      fontWeight: "bold",
                                    }}
                                    secondaryTypographyProps={{
                                      fontSize: "1.2rem",
                                      color: "#ff9800",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </ListItem>
                                <Divider />
                              </>
                            ) : null;
                          })()}

                        {/* Student-level CRM Status */}
                        {selectedDetailData.crmItem && (
                          <ListItem>
                            <ListItemText
                              primary=" CRM Status"
                              secondary={
                                <Chip
                                  label={
                                    getStudentStatus(
                                      selectedDetailData.crmItem,
                                      selectedDetailData.studentData._id
                                    ) || "N/A"
                                  }
                                  size="small"
                                  color="primary"
                                  sx={{ fontSize: "0.75rem", mt: 1 }}
                                />
                              }
                              primaryTypographyProps={{
                                fontSize: "0.875rem",
                                fontWeight: "bold",
                              }}
                            />
                          </ListItem>
                        )}
                      </List>
                    </ArgonBox>

                    {/* Parent Contact Information */}
                    <ArgonBox mb={3}>
                      <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                         Parent Contact
                      </ArgonTypography>
                      <List dense>
                        <ListItem>
                          <PersonIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Parent Name"
                            secondary={selectedDetailData.userData?.fullName || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <PhoneIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Phone"
                            secondary={selectedDetailData.userData?.phone || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <EmailIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Email"
                            secondary={selectedDetailData.userData?.email || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        {selectedDetailData.userData?.alternatePhone && (
                          <>
                            <Divider />
                            <ListItem>
                              <PhoneIcon sx={{ mr: 1, color: "#5e72e4" }} />
                              <ListItemText
                                primary="Alternate Phone"
                                secondary={selectedDetailData.userData.alternatePhone}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                        {selectedDetailData.userData?.address && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary=" Address"
                                secondary={selectedDetailData.userData.address}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                        {selectedDetailData.userData?.area && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary=" Area"
                                secondary={selectedDetailData.userData.area}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                        {selectedDetailData.userData?.city && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary=" City"
                                secondary={selectedDetailData.userData.city}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                        {selectedDetailData.userData?.preferredTutorLevel && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary=" Preferred Tutor Level / Fee Chosen"
                                secondary={selectedDetailData.userData.preferredTutorLevel}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem", color: "green" }}
                              />
                            </ListItem>
                          </>
                        )}
                      </List>
                    </ArgonBox>

                    {/* CRM & Payment Information */}
                    {selectedDetailData.crmItem && (
                      <ArgonBox mb={3}>
                        <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                           CRM & Payment Details
                        </ArgonTypography>
                        <List dense>
                          {/* Follow Up Status */}
                          <ListItem>
                            <ListItemText
                              primary=" Follow Up Status"
                              secondary={
                                <Chip
                                  label={selectedDetailData.crmItem.followUpStatus || "N/A"}
                                  size="small"
                                  color="primary"
                                  sx={{ fontSize: "0.75rem", mt: 0.5 }}
                                />
                              }
                              primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            />
                          </ListItem>
                          <Divider />

                          {/* OTM Amount */}
                          {selectedDetailData.crmItem.parentOTMAmount &&
                            selectedDetailData.crmItem.parentOTMAmount > 0 && (
                              <>
                                <ListItem>
                                  <ListItemText
                                    primary=" OTM Total Amount"
                                    secondary={`₹${selectedDetailData.crmItem.parentOTMAmount}`}
                                    primaryTypographyProps={{
                                      fontSize: "0.75rem",
                                      fontWeight: "bold",
                                    }}
                                    secondaryTypographyProps={{
                                      fontSize: "1rem",
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </ListItem>
                                <Divider />
                              </>
                            )}

                          {/* Partial Amount */}
                          {selectedDetailData.crmItem.partialAmount &&
                            selectedDetailData.crmItem.partialAmount > 0 && (
                              <>
                                <ListItem>
                                  <ListItemText
                                    primary=" Partial Amount Paid"
                                    secondary={`₹${selectedDetailData.crmItem.partialAmount}`}
                                    primaryTypographyProps={{
                                      fontSize: "0.75rem",
                                      fontWeight: "bold",
                                    }}
                                    secondaryTypographyProps={{
                                      fontSize: "1rem",
                                      color: "orange",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </ListItem>
                                <Divider />
                              </>
                            )}

                          {/* Payment Transaction ID */}
                          {selectedDetailData.crmItem.paymentTransactionId && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary=" Payment Transaction ID"
                                  secondary={selectedDetailData.crmItem.paymentTransactionId}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.75rem" }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}

                          {/* Payment Type */}
                          {selectedDetailData.crmItem.paymentType && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary=" Payment Type"
                                  secondary={selectedDetailData.crmItem.paymentType}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.875rem" }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}

                          {/* Last Status Updated */}
                          {selectedDetailData.crmItem.lastStatusUpdated && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary=" Last Status Updated"
                                  secondary={new Date(
                                    selectedDetailData.crmItem.lastStatusUpdated
                                  ).toLocaleString()}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.75rem" }}
                                />
                              </ListItem>
                            </>
                          )}
                        </List>
                      </ArgonBox>
                    )}

                    {/* Shortlisted Tutors Section - Only for Parent View */}
                    {selectedDetailData.type === "PARENT" &&
                      shortlistedTutors &&
                      shortlistedTutors.length > 0 && (
                        <ArgonBox mb={3}>
                          <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                             Shortlisted Tutors
                          </ArgonTypography>
                          {shortlistedLoading ? (
                            <ArgonBox display="flex" justifyContent="center" p={2}>
                              <CircularProgress size={30} />
                            </ArgonBox>
                          ) : shortlistedTutors && shortlistedTutors.length > 0 ? (
                            <Grid container spacing={1}>
                              {shortlistedTutors.map((tutor, index) => (
                                <Grid item xs={6} sm={4} md={3} key={tutor._id || index}>
                                  <ArgonBox
                                    sx={{
                                      backgroundColor: "rgba(94, 114, 228, 0.05)",
                                      borderRadius: "6px",
                                      border: "1px solid #e0e0e0",
                                      p: 1.5,
                                      minHeight: "180px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                      position: "relative",
                                      transition: "all 0.2s",
                                      "&:hover": {
                                        boxShadow: "0 2px 8px rgba(94, 114, 228, 0.2)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    {/* Rating in top-right corner */}
                                    {tutor.rating && tutor.rating.averageRating > 0 && (
                                      <Chip
                                        label={` ${tutor.rating.averageRating}`}
                                        size="small"
                                        color="warning"
                                        sx={{
                                          fontSize: "0.55rem",
                                          height: "18px",
                                          position: "absolute",
                                          top: 6,
                                          right: 6,
                                        }}
                                      />
                                    )}

                                    {/* Profile Image */}
                                    <Avatar
                                      src={tutor.profile || tutor.profileImg || tutor.profileImage}
                                      alt={tutor.name}
                                      sx={{
                                        width: 50,
                                        height: 50,
                                        fontSize: "1rem",
                                        mb: 1,
                                      }}
                                    >
                                      {tutor.name?.charAt(0)?.toUpperCase() || "T"}
                                    </Avatar>

                                    {/* Tutor Details */}
                                    <ArgonBox width="100%" sx={{ overflow: "hidden" }}>
                                      <ArgonTypography
                                        variant="caption"
                                        fontWeight="bold"
                                        color="primary"
                                        onClick={() => {
                                          console.log(
                                            "Navigating to tutor:",
                                            tutor._id || tutor.tutorId
                                          );
                                          navigate(`/tutors/profile/${tutor._id || tutor.tutorId}`);
                                        }}
                                        sx={{
                                          fontSize: "0.8rem",
                                          mb: 0.5,
                                          display: "block",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          cursor: "pointer",
                                          "&:hover": {
                                            textDecoration: "underline",
                                            color: "#1976d2",
                                          },
                                        }}
                                        title={tutor.name}
                                      >
                                        {tutor.name || "N/A"}
                                      </ArgonTypography>

                                      <ArgonBox
                                        display="flex"
                                        flexDirection="column"
                                        gap={0.3}
                                        alignItems="flex-start"
                                        width="100%"
                                      >
                                        {tutor.gender && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.gender}
                                          </ArgonTypography>
                                        )}
                                        {tutor.subjects && tutor.subjects !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              lineHeight: 1.2,
                                            }}
                                            title={tutor.subjects}
                                          >
                                             {tutor.subjects}
                                          </ArgonTypography>
                                        )}
                                        {tutor.classes && tutor.classes !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.classes}
                                          >
                                             {tutor.classes}
                                          </ArgonTypography>
                                        )}
                                        {tutor.boards && tutor.boards !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.boards}
                                          >
                                             {tutor.boards}
                                          </ArgonTypography>
                                        )}
                                        {tutor.experience && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="success"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.experience} yrs exp
                                          </ArgonTypography>
                                        )}
                                        {tutor.priceRange && tutor.priceRange !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="info"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.priceRange}
                                          </ArgonTypography>
                                        )}
                                      </ArgonBox>
                                    </ArgonBox>
                                  </ArgonBox>
                                </Grid>
                              ))}
                            </Grid>
                          ) : (
                            <ArgonBox p={1} textAlign="center">
                              <ArgonTypography
                                variant="caption"
                                color="text"
                                sx={{ fontSize: "0.7rem" }}
                              >
                                No tutors shortlisted yet
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      )}

                    {/* Interested Tutors Section (from Leads) - Only for Parent View */}
                    {selectedDetailData.type === "PARENT" &&
                      interestedTutors &&
                      interestedTutors.length > 0 && (
                        <ArgonBox mb={3}>
                          <ArgonBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                          >
                            <ArgonTypography variant="h6" fontWeight="bold" color="text">
                               Who&apos;s Interested / Said Yes
                            </ArgonTypography>
                            {selectedInterestedTutors.length > 0 && (
                              <ArgonButton
                                variant="gradient"
                                color="success"
                                size="medium"
                                onClick={handleShortlistSelected}
                                disabled={interestedLoading}
                                sx={{
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  fontWeight: "bold",
                                  px: 3,
                                  py: 1,
                                  boxShadow: "0 4px 12px rgba(76, 175, 80, 0.4)",
                                  "&:hover": {
                                    boxShadow: "0 6px 16px rgba(76, 175, 80, 0.5)",
                                    transform: "translateY(-1px)",
                                  },
                                }}
                              >
                                 Shortlist Selected ({selectedInterestedTutors.length})
                              </ArgonButton>
                            )}
                          </ArgonBox>
                          {interestedLoading ? (
                            <ArgonBox display="flex" justifyContent="center" p={2}>
                              <CircularProgress size={30} />
                            </ArgonBox>
                          ) : interestedTutors && interestedTutors.length > 0 ? (
                            <Grid container spacing={1}>
                              {interestedTutors.map((tutor, index) => (
                                <Grid item xs={6} sm={4} md={3} key={tutor._id || index}>
                                  <ArgonBox
                                    sx={{
                                      backgroundColor: selectedInterestedTutors.includes(tutor._id)
                                        ? "rgba(76, 175, 80, 0.15)"
                                        : "rgba(76, 175, 80, 0.05)",
                                      borderRadius: "6px",
                                      border: selectedInterestedTutors.includes(tutor._id)
                                        ? "2px solid #4caf50"
                                        : "1px solid #4caf50",
                                      p: 1.5,
                                      minHeight: "180px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                      position: "relative",
                                      transition: "all 0.2s",
                                      "&:hover": {
                                        boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    <Checkbox
                                      checked={selectedInterestedTutors.includes(tutor._id)}
                                      onChange={() => handleInterestedTutorToggle(tutor._id)}
                                      size="small"
                                      sx={{
                                        position: "absolute",
                                        top: 4,
                                        left: 4,
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        zIndex: 2,
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "1.3rem",
                                          color: selectedInterestedTutors.includes(tutor._id)
                                            ? "#4caf50"
                                            : "#757575",
                                        },
                                      }}
                                    />
                                    {/* Lead Badge in top-right corner */}
                                    <Chip
                                      label="Lead"
                                      size="small"
                                      color="success"
                                      sx={{
                                        fontSize: "0.5rem",
                                        height: "18px",
                                        position: "absolute",
                                        top: 6,
                                        right: 6,
                                        fontWeight: "bold",
                                      }}
                                    />

                                    {/* Profile Image */}
                                    <Avatar
                                      src={tutor.profileImage || tutor.profileImg}
                                      alt={tutor.name}
                                      sx={{
                                        width: 50,
                                        height: 50,
                                        fontSize: "1rem",
                                        mb: 1,
                                        border: "2px solid #4caf50",
                                      }}
                                    >
                                      {tutor.name?.charAt(0)?.toUpperCase() || "T"}
                                    </Avatar>

                                    {/* Tutor Details */}
                                    <ArgonBox width="100%" sx={{ overflow: "hidden" }}>
                                      <ArgonTypography
                                        variant="caption"
                                        fontWeight="bold"
                                        color="success"
                                        onClick={() => navigate(`/tutors/profile/${tutor._id}`)}
                                        sx={{
                                          fontSize: "0.8rem",
                                          mb: 0.5,
                                          display: "block",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          cursor: "pointer",
                                          "&:hover": {
                                            textDecoration: "underline",
                                            color: "#2e7d32",
                                          },
                                        }}
                                        title={tutor.name}
                                      >
                                        {tutor.name || "N/A"}
                                      </ArgonTypography>

                                      <ArgonBox
                                        display="flex"
                                        flexDirection="column"
                                        gap={0.3}
                                        alignItems="flex-start"
                                        width="100%"
                                      >
                                        {tutor.gender && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.gender}
                                          </ArgonTypography>
                                        )}
                                        {tutor.subjects && tutor.subjects !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              lineHeight: 1.2,
                                            }}
                                            title={tutor.subjects}
                                          >
                                             {tutor.subjects}
                                          </ArgonTypography>
                                        )}
                                        {tutor.classes && tutor.classes !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.classes}
                                          >
                                             {tutor.classes}
                                          </ArgonTypography>
                                        )}
                                        {tutor.boards && tutor.boards !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.boards}
                                          >
                                             {tutor.boards}
                                          </ArgonTypography>
                                        )}
                                        {tutor.experience && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="success"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.experience} yrs exp
                                          </ArgonTypography>
                                        )}
                                        {tutor.priceRange && tutor.priceRange !== "Not Set" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="info"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.priceRange}
                                          </ArgonTypography>
                                        )}
                                      </ArgonBox>
                                    </ArgonBox>
                                  </ArgonBox>
                                </Grid>
                              ))}
                            </Grid>
                          ) : (
                            <ArgonBox p={1} textAlign="center">
                              <ArgonTypography
                                variant="caption"
                                color="text"
                                sx={{ fontSize: "0.7rem" }}
                              >
                                No interested tutors from leads yet
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      )}
                  </>
                ) : (
                  // Show all content when no specific student selected
                  <>
                    {/* Basic Information */}
                    <ArgonBox mb={3}>
                      <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                         Basic Information
                      </ArgonTypography>
                      <List dense>
                        <ListItem>
                          <PersonIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Full Name"
                            secondary={selectedDetailData.userData?.fullName || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <EmailIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Email"
                            secondary={selectedDetailData.userData?.email || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <PhoneIcon sx={{ mr: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Phone"
                            secondary={selectedDetailData.userData?.phone || "N/A"}
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{ fontSize: "0.875rem" }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem sx={{ alignItems: "flex-start" }}>
                          <LocationOnIcon sx={{ mr: 1, mt: 1, color: "#5e72e4" }} />
                          <ListItemText
                            primary="Address"
                            secondary={
                              selectedDetailData.userData?.address?.trim() ||
                              selectedDetailData.userData?.generatedMapAddress?.trim() ||
                              "Not provided"
                            }
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                            secondaryTypographyProps={{
                              fontSize: "0.875rem",
                              sx: { whiteSpace: "pre-line", overflowWrap: "anywhere" },
                            }}
                          />
                        </ListItem>
                        {selectedDetailData.userData?.city && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary="City"
                                secondary={selectedDetailData.userData?.city || "N/A"}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                        {selectedDetailData.userData?.state && (
                          <>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary="State"
                                secondary={selectedDetailData.userData?.state || "N/A"}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                      </List>
                    </ArgonBox>

                    {/* CRM Information */}
                    <ArgonBox mb={3}>
                      <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                         CRM Status
                      </ArgonTypography>
                      <List dense>
                        <ListItem>
                          <ListItemText
                            primary="Current Status"
                            secondary={
                              <Chip
                                label={selectedDetailData.crmItem?.followUpStatus || "N/A"}
                                size="small"
                                color="primary"
                                sx={{ fontSize: "0.75rem" }}
                              />
                            }
                            primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                          />
                        </ListItem>
                        {selectedDetailData.crmItem?.lastStatusUpdated && (
                          <>
                            <Divider />
                            <ListItem>
                              <CalendarTodayIcon sx={{ mr: 1, color: "#5e72e4" }} />
                              <ListItemText
                                primary="Last Updated"
                                secondary={new Date(
                                  selectedDetailData.crmItem.lastStatusUpdated
                                ).toLocaleString()}
                                primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                                secondaryTypographyProps={{ fontSize: "0.875rem" }}
                              />
                            </ListItem>
                          </>
                        )}
                      </List>
                    </ArgonBox>

                    {/* Parent-specific: Students Information */}
                    {selectedDetailData.type === "PARENT" &&
                      selectedDetailData.userData?.students &&
                      selectedDetailData.userData.students.length > 0 && (
                        <ArgonBox mb={3}>
                          <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                             Students Information
                          </ArgonTypography>
                          {selectedDetailData.userData.students.map((student, index) => (
                            <ArgonBox
                              key={student._id || index}
                              mb={2}
                              p={2}
                              sx={{
                                border:
                                  selectedDetailData.studentData?._id === student._id
                                    ? "2px solid #5e72e4"
                                    : "1px solid #e0e0e0",
                                borderRadius: "8px",
                                backgroundColor:
                                  selectedDetailData.studentData?._id === student._id
                                    ? "rgba(94, 114, 228, 0.05)"
                                    : "white",
                              }}
                            >
                              <ArgonBox display="flex" alignItems="center" mb={1}>
                                <PersonIcon sx={{ mr: 1, color: "#5e72e4" }} />
                                <ArgonTypography variant="button" fontWeight="bold" color="text">
                                  {student.name || "N/A"}
                                </ArgonTypography>
                                {selectedDetailData.studentData?._id === student._id && (
                                  <Chip
                                    label="Selected"
                                    size="small"
                                    color="primary"
                                    sx={{ ml: 1, fontSize: "0.65rem" }}
                                  />
                                )}
                              </ArgonBox>
                              {(() => {
                                const className = student.class
                                  ? typeof student.class === "object"
                                    ? student.class.name
                                    : student.class
                                  : student.educationLevel || "";
                                const boardName = student.board
                                  ? typeof student.board === "object"
                                    ? student.board.name
                                    : student.board
                                  : "";
                                const subjectNames = Array.isArray(student.subjects)
                                  ? Array.from(
                                      new Set(
                                        student.subjects
                                          .map((s) => (typeof s === "object" ? s.name : s))
                                          .filter(Boolean)
                                      )
                                    ).join(", ")
                                  : "";
                                const studentGender = student.gender || "";
                                const tutorGender = student.tutorGenderPreference || "";
                                const tuitionMode = student.modeOfTuition || "";
                                const classesPerWeek = student.noOfClassesPerWeek
                                  ? `${student.noOfClassesPerWeek} days a week`
                                  : "";
                                const durationMinutes = student.preferredTimeDuration
                                  ? Number(student.preferredTimeDuration)
                                  : 0;
                                const durationLabel = durationMinutes
                                  ? `${durationMinutes} minutes (${(durationMinutes / 60).toFixed(
                                      1
                                    )} hours)`
                                  : "";
                                const slotPreferred = Array.isArray(student.slotPreferred)
                                  ? student.slotPreferred
                                      .map((slot) => {
                                        if (typeof slot === "string") return slot;
                                        if (
                                          slot &&
                                          (slot.startTime || slot.start) &&
                                          (slot.endTime || slot.end)
                                        ) {
                                          const start = slot.startTime || slot.start;
                                          const end = slot.endTime || slot.end;
                                          return `${start} - ${end}`;
                                        }
                                        return "";
                                      })
                                      .filter(Boolean)
                                      .join(", ")
                                  : typeof student.slotPreferred === "string"
                                  ? student.slotPreferred
                                  : "";

                                const subscriptionAmount = student.currentSubscription?.amount
                                  ? `₹${student.currentSubscription.amount}`
                                  : "";
                                const studentLevelAmount = selectedDetailData.crmItem
                                  ?.studentLevelAmounts
                                  ? selectedDetailData.crmItem.studentLevelAmounts.find(
                                      (sa) => sa.studentId === student._id
                                    )
                                  : null;
                                const studentStatus = selectedDetailData.crmItem
                                  ? getStudentStatus(selectedDetailData.crmItem, student._id)
                                  : null;

                                const infoRows = [
                                  { label: " Class", value: className },
                                  { label: " Board", value: boardName },
                                  { label: " Subjects", value: subjectNames },
                                  { label: " Student Gender", value: studentGender },
                                  { label: " Tutor Gender Preference", value: tutorGender },
                                  { label: " Mode of Tuition", value: tuitionMode },
                                  { label: " Classes Per Week", value: classesPerWeek },
                                  { label: " Class Duration", value: durationLabel },
                                  { label: " Preferred Time Slots", value: slotPreferred },
                                ];

                                if (subscriptionAmount) {
                                  infoRows.push({
                                    label: " Subscription Amount",
                                    value: subscriptionAmount,
                                    accent: "success",
                                  });
                                }

                                if (studentLevelAmount && studentLevelAmount.levelAmount > 0) {
                                  infoRows.push({
                                    label: " Student Level Amount (OTM)",
                                    value: `₹${studentLevelAmount.levelAmount}`,
                                    accent: "warning",
                                  });
                                }

                                if (studentStatus) {
                                  infoRows.push({
                                    label: " CRM Status",
                                    value: studentStatus,
                                    type: "chip",
                                  });
                                }

                                const visibleRows = infoRows.filter((row) => row.value);
                                if (visibleRows.length === 0) {
                                  return null;
                                }

                                return (
                                  <List dense>
                                    {visibleRows.map((detail, detailIndex) => (
                                      <Fragment key={`${detail.label}-${detailIndex}`}>
                                        <ListItem>
                                          <ListItemText
                                            primary={detail.label}
                                            secondary={
                                              detail.type === "chip" ? (
                                                <Chip
                                                  label={detail.value}
                                                  size="small"
                                                  color="primary"
                                                  sx={{ fontSize: "0.75rem", mt: 0.5 }}
                                                />
                                              ) : (
                                                detail.value
                                              )
                                            }
                                            primaryTypographyProps={{
                                              fontSize: "0.7rem",
                                              fontWeight: "bold",
                                            }}
                                            secondaryTypographyProps={
                                              detail.type === "chip"
                                                ? undefined
                                                : {
                                                    fontSize: "0.8rem",
                                                    fontWeight:
                                                      detail.accent === "success" ||
                                                      detail.accent === "warning"
                                                        ? "bold"
                                                        : "medium",
                                                    color:
                                                      detail.accent === "success"
                                                        ? "#2e7d32"
                                                        : detail.accent === "warning"
                                                        ? "#ff9800"
                                                        : "#344767",
                                                  }
                                            }
                                          />
                                        </ListItem>
                                        {detailIndex < visibleRows.length - 1 && <Divider />}
                                      </Fragment>
                                    ))}
                                  </List>
                                );
                              })()}
                            </ArgonBox>
                          ))}
                        </ArgonBox>
                      )}

                    {/* Financial Information (for parents) */}
                    {selectedDetailData.type === "PARENT" && (
                      <ArgonBox mb={3}>
                        <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                           Financial Information
                        </ArgonTypography>
                        <List dense>
                          {selectedDetailData.crmItem?.parentPlanAmount > 0 && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary="Plan Amount"
                                  secondary={`₹${selectedDetailData.crmItem.parentPlanAmount}`}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{
                                    fontSize: "0.875rem",
                                    color: "green",
                                    fontWeight: "bold",
                                  }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}
                          {selectedDetailData.crmItem?.parentOTMAmount > 0 && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary="OTM Amount"
                                  secondary={`₹${selectedDetailData.crmItem.parentOTMAmount}`}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{
                                    fontSize: "0.875rem",
                                    color: "green",
                                    fontWeight: "bold",
                                  }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}
                          {selectedDetailData.crmItem?.partialAmount > 0 && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary="Partial Amount"
                                  secondary={`₹${selectedDetailData.crmItem.partialAmount}`}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{
                                    fontSize: "0.875rem",
                                    color: "orange",
                                    fontWeight: "bold",
                                  }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}
                          {selectedDetailData.crmItem?.studentLevelAmounts &&
                            selectedDetailData.crmItem.studentLevelAmounts.length > 0 && (
                              <ListItem>
                                <ArgonBox width="100%">
                                  <ArgonTypography
                                    variant="caption"
                                    fontWeight="bold"
                                    color="text"
                                    display="block"
                                    mb={1}
                                  >
                                    Student Level Amounts:
                                  </ArgonTypography>
                                  {selectedDetailData.crmItem.studentLevelAmounts.map((sa) => {
                                    const student = selectedDetailData.userData?.students?.find(
                                      (s) => s._id === sa.studentId
                                    );
                                    return (
                                      <ArgonBox
                                        key={sa.studentId}
                                        display="flex"
                                        justifyContent="space-between"
                                        p={1}
                                        mb={0.5}
                                        sx={{
                                          backgroundColor: "#f8f9fa",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        <ArgonTypography variant="caption" color="text">
                                         {student?.name || "Unknown"}
                                        </ArgonTypography>
                                        <ArgonTypography
                                          variant="caption"
                                          fontWeight="bold"
                                          color="success"
                                        >
                                          ₹{sa.levelAmount || 0}
                                        </ArgonTypography>
                                      </ArgonBox>
                                    );
                                  })}
                                </ArgonBox>
                              </ListItem>
                            )}
                        </List>
                      </ArgonBox>
                    )}

                    {/* Tutor-specific Information */}
                    {selectedDetailData.type === "TUTOR" && (
                      <ArgonBox mb={3}>
                        <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                           Tutor Information
                        </ArgonTypography>
                        <List dense>
                          {selectedDetailData.userData?.qualification && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary="Qualification"
                                  secondary={selectedDetailData.userData.qualification}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.875rem" }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}
                          {selectedDetailData.userData?.experience && (
                            <>
                              <ListItem>
                                <ListItemText
                                  primary="Experience"
                                  secondary={`${selectedDetailData.userData.experience} years`}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.875rem" }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          )}
                          {selectedDetailData.userData?.subjects &&
                            selectedDetailData.userData.subjects.length > 0 && (
                              <>
                                <ListItem>
                                  <ListItemText
                                    primary="Subjects"
                                    secondary={selectedDetailData.userData.subjects
                                      .map((s) => s.name || s)
                                      .join(", ")}
                                    primaryTypographyProps={{
                                      fontSize: "0.75rem",
                                      fontWeight: "bold",
                                    }}
                                    secondaryTypographyProps={{ fontSize: "0.875rem" }}
                                  />
                                </ListItem>
                                <Divider />
                              </>
                            )}
                        </List>
                      </ArgonBox>
                    )}

                    {/* Additional Information */}
                    {selectedDetailData.userData?.createdAt && (
                      <ArgonBox mb={3}>
                        <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                           Timeline
                        </ArgonTypography>
                        <List dense>
                          <ListItem>
                            <ListItemText
                              primary="Registered On"
                              secondary={new Date(
                                selectedDetailData.userData.createdAt
                              ).toLocaleDateString()}
                              primaryTypographyProps={{ fontSize: "0.75rem", fontWeight: "bold" }}
                              secondaryTypographyProps={{ fontSize: "0.875rem" }}
                            />
                          </ListItem>
                          {selectedDetailData.userData?.updatedAt && (
                            <>
                              <Divider />
                              <ListItem>
                                <ListItemText
                                  primary="Last Updated"
                                  secondary={new Date(
                                    selectedDetailData.userData.updatedAt
                                  ).toLocaleDateString()}
                                  primaryTypographyProps={{
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                  }}
                                  secondaryTypographyProps={{ fontSize: "0.875rem" }}
                                />
                              </ListItem>
                            </>
                          )}
                        </List>
                      </ArgonBox>
                    )}

                    {/* Shortlisted Tutors Section - General Parent View */}
                    {selectedDetailData.type === "PARENT" &&
                      shortlistedTutors &&
                      shortlistedTutors.length > 0 && (
                        <ArgonBox mb={3}>
                          <ArgonTypography variant="h6" fontWeight="bold" color="text" mb={2}>
                             Shortlisted Tutors
                          </ArgonTypography>
                          {shortlistedLoading ? (
                            <ArgonBox display="flex" justifyContent="center" p={2}>
                              <CircularProgress size={30} />
                            </ArgonBox>
                          ) : shortlistedTutors && shortlistedTutors.length > 0 ? (
                            <Grid container spacing={1}>
                              {shortlistedTutors.map((tutor, index) => (
                                <Grid item xs={6} sm={4} md={3} key={tutor._id || index}>
                                  <ArgonBox
                                    sx={{
                                      backgroundColor: "rgba(94, 114, 228, 0.05)",
                                      borderRadius: "6px",
                                      border: "1px solid #e0e0e0",
                                      p: 1.5,
                                      minHeight: "180px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                      position: "relative",
                                      transition: "all 0.2s",
                                      "&:hover": {
                                        boxShadow: "0 2px 8px rgba(94, 114, 228, 0.2)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    {tutor.rating && tutor.rating.averageRating > 0 && (
                                      <Chip
                                        label={` ${tutor.rating.averageRating}`}
                                        size="small"
                                        color="warning"
                                        sx={{
                                          fontSize: "0.55rem",
                                          height: "18px",
                                          position: "absolute",
                                          top: 6,
                                          right: 6,
                                        }}
                                      />
                                    )}

                                    <Avatar
                                      src={tutor.profile || tutor.profileImg || tutor.profileImage}
                                      alt={tutor.name}
                                      sx={{
                                        width: 50,
                                        height: 50,
                                        fontSize: "1rem",
                                        mb: 1,
                                      }}
                                    >
                                      {tutor.name?.charAt(0)?.toUpperCase() || "T"}
                                    </Avatar>

                                    <ArgonBox width="100%" sx={{ overflow: "hidden" }}>
                                      <ArgonTypography
                                        variant="caption"
                                        fontWeight="bold"
                                        color="primary"
                                        onClick={() => navigate(`/tutors/profile/${tutor._id}`)}
                                        sx={{
                                          fontSize: "0.8rem",
                                          mb: 0.5,
                                          display: "block",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          cursor: "pointer",
                                          "&:hover": {
                                            textDecoration: "underline",
                                            color: "#1976d2",
                                          },
                                        }}
                                        title={tutor.name}
                                      >
                                        {tutor.name || "N/A"}
                                      </ArgonTypography>

                                      <ArgonBox
                                        display="flex"
                                        flexDirection="column"
                                        gap={0.3}
                                        alignItems="flex-start"
                                        width="100%"
                                      >
                                        {tutor.gender && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.gender}
                                          </ArgonTypography>
                                        )}
                                        {tutor.subjects && tutor.subjects !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              lineHeight: 1.2,
                                            }}
                                            title={tutor.subjects}
                                          >
                                             {tutor.subjects}
                                          </ArgonTypography>
                                        )}
                                        {tutor.classes && tutor.classes !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.classes}
                                          >
                                             {tutor.classes}
                                          </ArgonTypography>
                                        )}
                                        {tutor.boards && tutor.boards !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.boards}
                                          >
                                             {tutor.boards}
                                          </ArgonTypography>
                                        )}
                                        {tutor.experience && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="success"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.experience} yrs exp
                                          </ArgonTypography>
                                        )}
                                        {tutor.priceRange && tutor.priceRange !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="info"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.priceRange}
                                          </ArgonTypography>
                                        )}
                                      </ArgonBox>
                                    </ArgonBox>
                                  </ArgonBox>
                                </Grid>
                              ))}
                            </Grid>
                          ) : (
                            <ArgonBox p={1} textAlign="center">
                              <ArgonTypography
                                variant="caption"
                                color="text"
                                sx={{ fontSize: "0.7rem" }}
                              >
                                No tutors shortlisted yet
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      )}

                    {/* Interested Tutors Section - General Parent View */}
                    {selectedDetailData.type === "PARENT" &&
                      interestedTutors &&
                      interestedTutors.length > 0 && (
                        <ArgonBox mb={3}>
                          <ArgonBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                          >
                            <ArgonTypography variant="h6" fontWeight="bold" color="text">
                               Who&apos;s Interested / Said Yes
                            </ArgonTypography>
                            {selectedInterestedTutors.length > 0 && (
                              <ArgonButton
                                variant="gradient"
                                color="success"
                                size="medium"
                                onClick={handleShortlistSelected}
                                disabled={interestedLoading}
                                sx={{
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  fontWeight: "bold",
                                  px: 3,
                                  py: 1,
                                  boxShadow: "0 4px 12px rgba(76, 175, 80, 0.4)",
                                  "&:hover": {
                                    boxShadow: "0 6px 16px rgba(76, 175, 80, 0.5)",
                                    transform: "translateY(-1px)",
                                  },
                                }}
                              >
                                 Shortlist Selected ({selectedInterestedTutors.length})
                              </ArgonButton>
                            )}
                          </ArgonBox>
                          {interestedLoading ? (
                            <ArgonBox display="flex" justifyContent="center" p={2}>
                              <CircularProgress size={30} />
                            </ArgonBox>
                          ) : interestedTutors && interestedTutors.length > 0 ? (
                            <Grid container spacing={1}>
                              {interestedTutors.map((tutor, index) => (
                                <Grid item xs={6} sm={4} md={3} key={tutor._id || index}>
                                  <ArgonBox
                                    sx={{
                                      backgroundColor: selectedInterestedTutors.includes(tutor._id)
                                        ? "rgba(76, 175, 80, 0.15)"
                                        : "rgba(76, 175, 80, 0.05)",
                                      borderRadius: "6px",
                                      border: selectedInterestedTutors.includes(tutor._id)
                                        ? "2px solid #4caf50"
                                        : "1px solid #4caf50",
                                      p: 1.5,
                                      minHeight: "180px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                      position: "relative",
                                      transition: "all 0.2s",
                                      "&:hover": {
                                        boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    <Checkbox
                                      checked={selectedInterestedTutors.includes(tutor._id)}
                                      onChange={() => handleInterestedTutorToggle(tutor._id)}
                                      size="small"
                                      sx={{
                                        position: "absolute",
                                        top: 4,
                                        left: 4,
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        zIndex: 2,
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "1.3rem",
                                          color: selectedInterestedTutors.includes(tutor._id)
                                            ? "#4caf50"
                                            : "#757575",
                                        },
                                      }}
                                    />
                                    <Chip
                                      label="Lead"
                                      size="small"
                                      color="success"
                                      sx={{
                                        fontSize: "0.5rem",
                                        height: "18px",
                                        position: "absolute",
                                        top: 6,
                                        right: 6,
                                        fontWeight: "bold",
                                      }}
                                    />

                                    <Avatar
                                      src={tutor.profileImage || tutor.profileImg}
                                      alt={tutor.name}
                                      sx={{
                                        width: 50,
                                        height: 50,
                                        fontSize: "1rem",
                                        mb: 1,
                                        border: "2px solid #4caf50",
                                      }}
                                    >
                                      {tutor.name?.charAt(0)?.toUpperCase() || "T"}
                                    </Avatar>

                                    <ArgonBox width="100%" sx={{ overflow: "hidden" }}>
                                      <ArgonTypography
                                        variant="caption"
                                        fontWeight="bold"
                                        color="success"
                                        onClick={() => navigate(`/tutors/profile/${tutor._id}`)}
                                        sx={{
                                          fontSize: "0.8rem",
                                          mb: 0.5,
                                          display: "block",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          cursor: "pointer",
                                          "&:hover": {
                                            textDecoration: "underline",
                                            color: "#2e7d32",
                                          },
                                        }}
                                        title={tutor.name}
                                      >
                                        {tutor.name || "N/A"}
                                      </ArgonTypography>

                                      <ArgonBox
                                        display="flex"
                                        flexDirection="column"
                                        gap={0.3}
                                        alignItems="flex-start"
                                        width="100%"
                                      >
                                        {tutor.gender && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.gender}
                                          </ArgonTypography>
                                        )}
                                        {tutor.subjects && tutor.subjects !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              lineHeight: 1.2,
                                            }}
                                            title={tutor.subjects}
                                          >
                                             {tutor.subjects}
                                          </ArgonTypography>
                                        )}
                                        {tutor.classes && tutor.classes !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.classes}
                                          >
                                             {tutor.classes}
                                          </ArgonTypography>
                                        )}
                                        {tutor.boards && tutor.boards !== "N/A" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="text"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 1,
                                              WebkitBoxOrient: "vertical",
                                            }}
                                            title={tutor.boards}
                                          >
                                             {tutor.boards}
                                          </ArgonTypography>
                                        )}
                                        {tutor.experience && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="success"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.experience} yrs exp
                                          </ArgonTypography>
                                        )}
                                        {tutor.priceRange && tutor.priceRange !== "Not Set" && (
                                          <ArgonTypography
                                            variant="caption"
                                            color="info"
                                            sx={{
                                              fontSize: "0.65rem",
                                              width: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                             {tutor.priceRange}
                                          </ArgonTypography>
                                        )}
                                      </ArgonBox>
                                    </ArgonBox>
                                  </ArgonBox>
                                </Grid>
                              ))}
                            </Grid>
                          ) : (
                            <ArgonBox p={1} textAlign="center">
                              <ArgonTypography
                                variant="caption"
                                color="text"
                                sx={{ fontSize: "0.7rem" }}
                              >
                                No interested tutors from leads yet
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      )}
                  </>
                )}
              </ArgonBox>
            </ArgonBox>
          ) : null}
        </Drawer>

        {/* Combine/Separate Confirmation Dialog */}
        <Dialog
          open={combineConfirmDialog}
          onClose={handleCancelCombineToggle}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              pb: 1,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <ArgonBox
              sx={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 107, 107, 0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArgonTypography variant="h3" color="error">

              </ArgonTypography>
            </ArgonBox>
            <ArgonBox>
              <ArgonTypography variant="h5" fontWeight="bold" color="dark">
                {pendingCombineAction && combinedParents[pendingCombineAction]
                  ? "Separate Cards"
                  : "Combine Cards"}
              </ArgonTypography>
              <ArgonTypography variant="caption" color="text">
                This action requires confirmation
              </ArgonTypography>
            </ArgonBox>
            <IconButton
              onClick={handleCancelCombineToggle}
              sx={{
                marginLeft: "auto",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.05)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ pt: 3, pb: 2 }}>
            <ArgonBox
              sx={{
                backgroundColor: "rgba(255, 193, 7, 0.1)",
                border: "1px solid rgba(255, 193, 7, 0.3)",
                borderRadius: "8px",
                p: 2.5,
                mb: 2,
              }}
            >
              <ArgonTypography variant="body2" color="dark" fontWeight="medium">
                {pendingCombineAction && combinedParents[pendingCombineAction]
                  ? "Are you sure you want to separate this parent's cards? Each student will have a separate card."
                  : "Are you sure you want to combine this parent's cards? All students will be shown in a single card."}
              </ArgonTypography>
            </ArgonBox>

            <ArgonTypography variant="caption" color="text" display="block">
              This action can be undone later.
            </ArgonTypography>
          </DialogContent>

          <DialogActions
            sx={{
              px: 3,
              pb: 3,
              gap: 1,
              borderTop: "1px solid #e0e0e0",
              pt: 2,
            }}
          >
            <ArgonButton
              onClick={handleCancelCombineToggle}
              variant="outlined"
              color="dark"
              size="medium"
              sx={{
                textTransform: "none",
                fontWeight: "medium",
                borderRadius: "8px",
                px: 3,
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              onClick={handleConfirmCombineToggle}
              variant="gradient"
              color={
                pendingCombineAction && combinedParents[pendingCombineAction] ? "info" : "success"
              }
              size="medium"
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: "8px",
                px: 3,
              }}
            >
              {pendingCombineAction && combinedParents[pendingCombineAction]
                ? "Separate Cards"
                : "Combine Cards"}
            </ArgonButton>
          </DialogActions>
        </Dialog>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UnifiedCRM;
